/* tslint:disable */
/* eslint-disable */
/**
 * Identity
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AuthenticationLogoutResponse
 */
export interface AuthenticationLogoutResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationLogoutResponse
     */
    'redirectUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthenticationLogoutResponse
     */
    'isSSOLogout': boolean;
}
/**
 * 
 * @export
 * @interface AuthenticationResetPasswordDTO
 */
export interface AuthenticationResetPasswordDTO {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResetPasswordDTO
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResetPasswordDTO
     */
    'confirmPassword': string;
}
/**
 * 
 * @export
 * @interface ClientAvailableClient
 */
export interface ClientAvailableClient {
    /**
     * 
     * @type {string}
     * @memberof ClientAvailableClient
     */
    'clientID': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAvailableClient
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientAvailableClient
     */
    'subdomain': string;
}
/**
 * 
 * @export
 * @interface ClientClientResponseDTO
 */
export interface ClientClientResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof ClientClientResponseDTO
     */
    'clientID': string;
    /**
     * 
     * @type {string}
     * @memberof ClientClientResponseDTO
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientClientResponseDTO
     */
    'subdomain': string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientClientResponseDTO
     */
    'servicesClient': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ClientManageClientsSortColumn = {
    ClientName: 1,
    ServiceLines: 2,
    Status: 3
} as const;

export type ClientManageClientsSortColumn = typeof ClientManageClientsSortColumn[keyof typeof ClientManageClientsSortColumn];


/**
 * 
 * @export
 * @interface CommandsAdminChangePasswordCommand
 */
export interface CommandsAdminChangePasswordCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsAdminChangePasswordCommand
     */
    'userID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsAdminChangePasswordCommand
     */
    'newPassword': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsAdminChangePasswordCommand
     */
    'confirmPassword': string;
}
/**
 * 
 * @export
 * @interface CommandsChangeExpiredPasswordRequest
 */
export interface CommandsChangeExpiredPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsChangeExpiredPasswordRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsChangeExpiredPasswordRequest
     */
    'oldPassword': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsChangeExpiredPasswordRequest
     */
    'newPassword': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsChangeExpiredPasswordRequest
     */
    'confirmPassword': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsChangeExpiredPasswordRequest
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface CommandsChangePasswordCommand
 */
export interface CommandsChangePasswordCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsChangePasswordCommand
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsChangePasswordCommand
     */
    'oldPassword': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsChangePasswordCommand
     */
    'newPassword': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsChangePasswordCommand
     */
    'confirmPassword': string;
}
/**
 * 
 * @export
 * @interface CommandsCreateClientCommand
 */
export interface CommandsCreateClientCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateClientCommand
     */
    'name': string;
    /**
     * 
     * @type {Array<EnumerationsServiceType>}
     * @memberof CommandsCreateClientCommand
     */
    'serviceLines': Array<EnumerationsServiceType>;
    /**
     * 
     * @type {number}
     * @memberof CommandsCreateClientCommand
     */
    'bcpProviderID': number;
    /**
     * 
     * @type {number}
     * @memberof CommandsCreateClientCommand
     */
    'wfaProviderID'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommandsCreateClientCommand
     */
    'oldClientID': number;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateClientCommand
     */
    'servicesClient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateClientCommand
     */
    'isCompetitiveConsultant': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsCreateClientCommand
     */
    'emailDomains'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateClientCommand
     */
    'berkshireWestDefaults': boolean;
}
/**
 * 
 * @export
 * @interface CommandsCreateClientDTO
 */
export interface CommandsCreateClientDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateClientDTO
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateClientDTO
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateClientDTO
     */
    'clientID': string;
}
/**
 * 
 * @export
 * @interface CommandsCreateDocumentCenterUserRequest
 */
export interface CommandsCreateDocumentCenterUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateDocumentCenterUserRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateDocumentCenterUserRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateDocumentCenterUserRequest
     */
    'lastName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateDocumentCenterUserRequest
     */
    'isConsultant': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateDocumentCenterUserRequest
     */
    'dropboxName': string;
}
/**
 * 
 * @export
 * @interface CommandsCreateSRAUserRequest
 */
export interface CommandsCreateSRAUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateSRAUserRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateSRAUserRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateSRAUserRequest
     */
    'lastName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateSRAUserRequest
     */
    'isConsultant': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateSRAUserRequest
     */
    'dropboxName': string;
}
/**
 * 
 * @export
 * @interface CommandsCreateUserCommand
 */
export interface CommandsCreateUserCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateUserCommand
     */
    'newUserID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateUserCommand
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateUserCommand
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateUserCommand
     */
    'lastName': string;
    /**
     * 
     * @type {EnumerationsRole}
     * @memberof CommandsCreateUserCommand
     */
    'roleID': EnumerationsRole;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsCreateUserCommand
     */
    'serviceIDs': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsCreateUserCommand
     */
    'servicePermissionIDs': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsCreateUserCommand
     */
    'planIDs': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsCreateUserCommand
     */
    'analysisIDs': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsCreateUserCommand
     */
    'projectIDs': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateUserCommand
     */
    'isPublishRequest': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateUserCommand
     */
    'isConsultant': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateUserCommand
     */
    'dropboxName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateUserCommand
     */
    'alternateSSOID'?: string | null;
}


/**
 * 
 * @export
 * @interface CommandsEditUserCommand
 */
export interface CommandsEditUserCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsEditUserCommand
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsEditUserCommand
     */
    'lastName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsEditUserCommand
     */
    'receiveSystemAlertEmails': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsEditUserCommand
     */
    'accessibilityMode': boolean;
}
/**
 * 
 * @export
 * @interface CommandsLoginCommand
 */
export interface CommandsLoginCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsLoginCommand
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsLoginCommand
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsLoginCommand
     */
    'redirectID'?: string | null;
}
/**
 * 
 * @export
 * @interface CommandsLoginResponseDTO
 */
export interface CommandsLoginResponseDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CommandsLoginResponseDTO
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsLoginResponseDTO
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsLoginResponseDTO
     */
    'passwordExpired'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsLoginResponseDTO
     */
    'defaultClientSubdomain': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsLoginResponseDTO
     */
    'validSubdomains': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsLoginResponseDTO
     */
    'isSystemAdmin': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsLoginResponseDTO
     */
    'expiredPasswordToken': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsLoginResponseDTO
     */
    'redirectURL': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsLoginResponseDTO
     */
    'redirectToMFA': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsLoginResponseDTO
     */
    'ssoRequired': boolean;
}
/**
 * 
 * @export
 * @interface CommandsMFALoginResponse
 */
export interface CommandsMFALoginResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CommandsMFALoginResponse
     */
    'success': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsMFALoginResponse
     */
    'isLockedOut': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsMFALoginResponse
     */
    'defaultClientSubdomain': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsMFALoginResponse
     */
    'validSubdomains': Array<string>;
}
/**
 * 
 * @export
 * @interface CommandsSaveSSOSettingsRequest
 */
export interface CommandsSaveSSOSettingsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CommandsSaveSSOSettingsRequest
     */
    'ssoOn': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsSaveSSOSettingsRequest
     */
    'entityName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsSaveSSOSettingsRequest
     */
    'loginURL': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsSaveSSOSettingsRequest
     */
    'logoutURL': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsSaveSSOSettingsRequest
     */
    'signRequest': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsSaveSSOSettingsRequest
     */
    'signAssertion': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsSaveSSOSettingsRequest
     */
    'requireSSO': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsSaveSSOSettingsRequest
     */
    'useAlternateSSOID': boolean;
}
/**
 * 
 * @export
 * @interface CommandsUpdateClientCommand
 */
export interface CommandsUpdateClientCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateClientCommand
     */
    'clientID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateClientCommand
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateClientCommand
     */
    'status': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsUpdateClientCommand
     */
    'serviceLines': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsUpdateClientCommand
     */
    'emailDomains'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof CommandsUpdateClientCommand
     */
    'oldClientID': number;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateClientCommand
     */
    'servicesClient': boolean;
    /**
     * 
     * @type {number}
     * @memberof CommandsUpdateClientCommand
     */
    'wfaProviderID'?: number | null;
}
/**
 * 
 * @export
 * @interface CommandsUpdateDefaultUserRoleCommand
 */
export interface CommandsUpdateDefaultUserRoleCommand {
    /**
     * 
     * @type {number}
     * @memberof CommandsUpdateDefaultUserRoleCommand
     */
    'roleID': number;
}
/**
 * 
 * @export
 * @interface CommandsUpdateDefaultUserRoleResponse
 */
export interface CommandsUpdateDefaultUserRoleResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateDefaultUserRoleResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateDefaultUserRoleResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface CommandsUpdateUserCommand
 */
export interface CommandsUpdateUserCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateUserCommand
     */
    'userID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateUserCommand
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateUserCommand
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateUserCommand
     */
    'lastName': string;
    /**
     * 
     * @type {EnumerationsRole}
     * @memberof CommandsUpdateUserCommand
     */
    'roleID': EnumerationsRole;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsUpdateUserCommand
     */
    'serviceIDs': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsUpdateUserCommand
     */
    'servicePermissionIDs': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsUpdateUserCommand
     */
    'planIDs': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsUpdateUserCommand
     */
    'analysisIDs': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsUpdateUserCommand
     */
    'projectIDs': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateUserCommand
     */
    'isConsultant': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateUserCommand
     */
    'dropboxName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateUserCommand
     */
    'alternateSSOID'?: string | null;
}


/**
 * 
 * @export
 * @interface CommandsUpdateUserResponse
 */
export interface CommandsUpdateUserResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateUserResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateUserResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateUserResponse
     */
    'domainValidationError': boolean;
}
/**
 * 
 * @export
 * @interface CommandsUploadCertificateResponse
 */
export interface CommandsUploadCertificateResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsUploadCertificateResponse
     */
    'certificateName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUploadCertificateResponse
     */
    'certificateExpirationDate': string;
}
/**
 * 
 * @export
 * @interface CommandsUploadMetadataFileResponse
 */
export interface CommandsUploadMetadataFileResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUploadMetadataFileResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsUploadMetadataFileResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUploadMetadataFileResponse
     */
    'entityName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUploadMetadataFileResponse
     */
    'loginURL': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUploadMetadataFileResponse
     */
    'logoutURL': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUploadMetadataFileResponse
     */
    'certificateName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUploadMetadataFileResponse
     */
    'certificateExpirationDate': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsClaim = {
    WriteDataViz: 1,
    ReadDataViz: 2,
    WriteInsights: 3,
    ReadInsights: 4,
    WriteReports: 5,
    ReadReports: 6,
    WriteCommunication: 7,
    ReadCommunication: 8,
    WriteDeliverables: 9,
    ReadDeliverables: 10,
    WriteDocumentCenter: 11,
    ReadDocumentCenter: 12,
    WriteUserAdministration: 13,
    ReadUserAdministration: 14,
    WriteClientSettings: 15,
    ReadClientSettings: 16,
    WriteTenantAdministration: 17,
    ReadTenantAdministration: 18,
    DeleteDocumentCenter: 19,
    ReadDocumentCenterUnassigned: 20,
    WriteDocumentCenterUnassigned: 21,
    ReadAllClients: 22,
    ReadWriteClientSupportAccess: 23,
    ReadWriteAdminSupportAccess: 24,
    ReadResourceLibrary: 25,
    ChangeDocumentClient: 26,
    ReadWriteSystemAlerts: 27,
    AddEmailDomain: 28,
    ViewAs: 29
} as const;

export type EnumerationsClaim = typeof EnumerationsClaim[keyof typeof EnumerationsClaim];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsComplianceType = {
    EO11246: 1,
    NonDiscrimination: 2,
    IWD503VETSVEVRAALegacy: 3,
    StateandLocalReporting: 4,
    AttorneyClientPrivilege: 5,
    ProportionalAnalyses: 6,
    IWD503VETSVEVRAA2026: 7
} as const;

export type EnumerationsComplianceType = typeof EnumerationsComplianceType[keyof typeof EnumerationsComplianceType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsFirstRoute = {
    DocumentCenter: 1,
    DataVizOverview: 2,
    Reports: 3,
    SupportAccess: 4,
    ServiceDeliverables: 5,
    UserManagement: 6
} as const;

export type EnumerationsFirstRoute = typeof EnumerationsFirstRoute[keyof typeof EnumerationsFirstRoute];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsLogoutType = {
    Manual: 1,
    Timeout: 2
} as const;

export type EnumerationsLogoutType = typeof EnumerationsLogoutType[keyof typeof EnumerationsLogoutType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsPlanType = {
    Regular: 0,
    Master: 1,
    Sub: 2
} as const;

export type EnumerationsPlanType = typeof EnumerationsPlanType[keyof typeof EnumerationsPlanType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsRole = {
    BerkshireSystemAdmin: 1,
    BerkshireDataAdmin: 2,
    BerkshireProductSupport: 3,
    BerkshireConsultant: 4,
    Admin: 5,
    ServiceOwner: 6,
    ReportViewer: 7,
    ReportandDataVizViewer: 8,
    ReportDataVizandInsightsViewer: 9,
    BerkshirePSAdmin: 10,
    BerkshireCSLeadership: 11,
    CompetitiveConsultant: 12,
    ServiceDeliverableViewer: 13,
    NonReportsServiceOwner: 14,
    DataVizOnlyViewer: 15,
    ServiceDeliverableandDataVizViewer: 16
} as const;

export type EnumerationsRole = typeof EnumerationsRole[keyof typeof EnumerationsRole];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsServiceType = {
    Compliance: 0,
    Compensation: 1,
    DEI: 2,
    EEO: 3,
    Vets: 4,
    Audit: 5,
    Custom: 6,
    Tools: 7,
    WorkforceAnalytics: 8,
    GoodFaithEfforts: 9
} as const;

export type EnumerationsServiceType = typeof EnumerationsServiceType[keyof typeof EnumerationsServiceType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsSortDirection = {
    Ascending: 1,
    Descending: 2
} as const;

export type EnumerationsSortDirection = typeof EnumerationsSortDirection[keyof typeof EnumerationsSortDirection];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsSupportAccessStatus = {
    Expired: 1,
    Active: 2,
    Pending: 3,
    Denied: 4,
    Cancelled: 5
} as const;

export type EnumerationsSupportAccessStatus = typeof EnumerationsSupportAccessStatus[keyof typeof EnumerationsSupportAccessStatus];


/**
 * 
 * @export
 * @interface ModelsRole
 */
export interface ModelsRole {
    /**
     * 
     * @type {number}
     * @memberof ModelsRole
     */
    'roleID': number;
    /**
     * 
     * @type {string}
     * @memberof ModelsRole
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsRole
     */
    'isBerkshire': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsRole
     */
    'isCompetitor': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsRole
     */
    'canViewAs': boolean;
}
/**
 * 
 * @export
 * @interface QueriesActiveSupportAccess
 */
export interface QueriesActiveSupportAccess {
    /**
     * 
     * @type {string}
     * @memberof QueriesActiveSupportAccess
     */
    'supportAccessID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesActiveSupportAccess
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesActiveSupportAccess
     */
    'dateExpired': string;
}
/**
 * 
 * @export
 * @interface QueriesClientDTO
 */
export interface QueriesClientDTO {
    /**
     * 
     * @type {string}
     * @memberof QueriesClientDTO
     */
    'clientID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesClientDTO
     */
    'clientName': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesClientDTO
     */
    'status': boolean;
    /**
     * 
     * @type {string}
     * @memberof QueriesClientDTO
     */
    'bcpProviderName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof QueriesClientDTO
     */
    'wfaProviderID'?: number | null;
    /**
     * 
     * @type {Array<QueriesGetServicesResponse>}
     * @memberof QueriesClientDTO
     */
    'services': Array<QueriesGetServicesResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesClientDTO
     */
    'twoFactorAuthOn': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesClientDTO
     */
    'emailDomains': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesClientDTO
     */
    'servicesClient': boolean;
    /**
     * 
     * @type {number}
     * @memberof QueriesClientDTO
     */
    'oldClientID'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesClientDTO
     */
    'competingConsultant': boolean;
}
/**
 * 
 * @export
 * @interface QueriesClientSSOInfo
 */
export interface QueriesClientSSOInfo {
    /**
     * 
     * @type {string}
     * @memberof QueriesClientSSOInfo
     */
    'clientID': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesClientSSOInfo
     */
    'ssoOn': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesClientSSOInfo
     */
    'ssoRequired': boolean;
}
/**
 * 
 * @export
 * @interface QueriesDocumentCenterUser
 */
export interface QueriesDocumentCenterUser {
    /**
     * 
     * @type {string}
     * @memberof QueriesDocumentCenterUser
     */
    'userID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesDocumentCenterUser
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesDocumentCenterUser
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesDocumentCenterUser
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface QueriesGetActiveSupportAccessResponse
 */
export interface QueriesGetActiveSupportAccessResponse {
    /**
     * 
     * @type {Array<QueriesActiveSupportAccess>}
     * @memberof QueriesGetActiveSupportAccessResponse
     */
    'activeSupportAccessRequests': Array<QueriesActiveSupportAccess>;
}
/**
 * 
 * @export
 * @interface QueriesGetAdminsForClientQuery
 */
export interface QueriesGetAdminsForClientQuery {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAdminsForClientQuery
     */
    'clientID': string;
}
/**
 * 
 * @export
 * @interface QueriesGetAllClientsResponse
 */
export interface QueriesGetAllClientsResponse {
    /**
     * 
     * @type {number}
     * @memberof QueriesGetAllClientsResponse
     */
    'rowCount': number;
    /**
     * 
     * @type {Array<QueriesGetAllClientsRow>}
     * @memberof QueriesGetAllClientsResponse
     */
    'rows': Array<QueriesGetAllClientsRow>;
}
/**
 * 
 * @export
 * @interface QueriesGetAllClientsRow
 */
export interface QueriesGetAllClientsRow {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAllClientsRow
     */
    'clientID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAllClientsRow
     */
    'clientName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetAllClientsRow
     */
    'serviceLines': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetAllClientsRow
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface QueriesGetAllUsersResponse
 */
export interface QueriesGetAllUsersResponse {
    /**
     * 
     * @type {number}
     * @memberof QueriesGetAllUsersResponse
     */
    'rowCount': number;
    /**
     * 
     * @type {Array<QueriesGetAllUsersRow>}
     * @memberof QueriesGetAllUsersResponse
     */
    'rows': Array<QueriesGetAllUsersRow>;
}
/**
 * 
 * @export
 * @interface QueriesGetAllUsersRow
 */
export interface QueriesGetAllUsersRow {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAllUsersRow
     */
    'userID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAllUsersRow
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAllUsersRow
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAllUsersRow
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetAllUsersRow
     */
    'serviceLines': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAllUsersRow
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAllUsersRow
     */
    'role': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetAllUsersRow
     */
    'ssoOn': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetAllUsersRow
     */
    'requireSSO': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetAllUsersRow
     */
    'twoFactorAuthOn': boolean;
}
/**
 * 
 * @export
 * @interface QueriesGetClientAndDurationResponse
 */
export interface QueriesGetClientAndDurationResponse {
    /**
     * 
     * @type {Array<SupportAccessDurationDTO>}
     * @memberof QueriesGetClientAndDurationResponse
     */
    'durations': Array<SupportAccessDurationDTO>;
    /**
     * 
     * @type {Array<ClientClientResponseDTO>}
     * @memberof QueriesGetClientAndDurationResponse
     */
    'clients': Array<ClientClientResponseDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetClientCreationResponse
 */
export interface QueriesGetClientCreationResponse {
    /**
     * 
     * @type {Array<QueriesGetServicesResponse>}
     * @memberof QueriesGetClientCreationResponse
     */
    'services': Array<QueriesGetServicesResponse>;
    /**
     * 
     * @type {Array<QueriesProviderDTO>}
     * @memberof QueriesGetClientCreationResponse
     */
    'bcpProviders': Array<QueriesProviderDTO>;
    /**
     * 
     * @type {Array<QueriesProviderDTO>}
     * @memberof QueriesGetClientCreationResponse
     */
    'wfaProviders': Array<QueriesProviderDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetClientEditResponse
 */
export interface QueriesGetClientEditResponse {
    /**
     * 
     * @type {QueriesClientDTO}
     * @memberof QueriesGetClientEditResponse
     */
    'clientData': QueriesClientDTO;
    /**
     * 
     * @type {Array<QueriesProviderDTO>}
     * @memberof QueriesGetClientEditResponse
     */
    'wfaProviders': Array<QueriesProviderDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetClientSupportAccessResponse
 */
export interface QueriesGetClientSupportAccessResponse {
    /**
     * 
     * @type {QueriesSupportAccessActiveOrPendingRequest}
     * @memberof QueriesGetClientSupportAccessResponse
     */
    'activeOrPendingRequest': QueriesSupportAccessActiveOrPendingRequest;
    /**
     * 
     * @type {Array<QueriesSupportAccessHistoryDates>}
     * @memberof QueriesGetClientSupportAccessResponse
     */
    'history': Array<QueriesSupportAccessHistoryDates>;
}
/**
 * 
 * @export
 * @interface QueriesGetDropboxResponse
 */
export interface QueriesGetDropboxResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDropboxResponse
     */
    'userID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDropboxResponse
     */
    'initials': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDropboxResponse
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface QueriesGetEmailTemplateResponse
 */
export interface QueriesGetEmailTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetEmailTemplateResponse
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetEmailTemplateResponse
     */
    'body': string;
}
/**
 * 
 * @export
 * @interface QueriesGetLoggedInUserDataResponse
 */
export interface QueriesGetLoggedInUserDataResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'viewAsUserID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'loggedInUserID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'clientID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'dropboxName': string;
    /**
     * 
     * @type {EnumerationsRole}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'roleID': EnumerationsRole;
    /**
     * 
     * @type {Array<QueriesUserServiceDTO>}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'services': Array<QueriesUserServiceDTO>;
    /**
     * 
     * @type {Array<EnumerationsClaim>}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'claims': Array<EnumerationsClaim>;
    /**
     * 
     * @type {Array<ClientClientResponseDTO>}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'accessedClients': Array<ClientClientResponseDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'userClientCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'hasOpenSupportAccess': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'hasPendingSupportAccess': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'clientRequiresTwoFactorAuth': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'receiveSystemAlertEmails': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'clientIsCompetitiveConsultant': boolean;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'unreadSystemAlertCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'hasUnviewedNotifications': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'accessibilityMode': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetLoggedInUserDataResponse
     */
    'hasWFAAccess': boolean;
}


/**
 * 
 * @export
 * @interface QueriesGetPendingSupportAccessResponse
 */
export interface QueriesGetPendingSupportAccessResponse {
    /**
     * 
     * @type {Array<QueriesPendingSupportAccess>}
     * @memberof QueriesGetPendingSupportAccessResponse
     */
    'pendingSupportAccessRequests': Array<QueriesPendingSupportAccess>;
}
/**
 * 
 * @export
 * @interface QueriesGetPreviousAccessResponse
 */
export interface QueriesGetPreviousAccessResponse {
    /**
     * 
     * @type {number}
     * @memberof QueriesGetPreviousAccessResponse
     */
    'rowCount': number;
    /**
     * 
     * @type {Array<SupportAccessPreviousAccessDTO>}
     * @memberof QueriesGetPreviousAccessResponse
     */
    'rows': Array<SupportAccessPreviousAccessDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetSSOOnResponse
 */
export interface QueriesGetSSOOnResponse {
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetSSOOnResponse
     */
    'ssoOn': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetSSOOnResponse
     */
    'useAlternateSSOID': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetSSOOnResponse
     */
    'requireSSO': boolean;
}
/**
 * 
 * @export
 * @interface QueriesGetSSOSettingsResponse
 */
export interface QueriesGetSSOSettingsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetSSOSettingsResponse
     */
    'ssoOn': boolean;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSSOSettingsResponse
     */
    'entityName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSSOSettingsResponse
     */
    'loginURL': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSSOSettingsResponse
     */
    'logoutURL': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetSSOSettingsResponse
     */
    'signRequest': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetSSOSettingsResponse
     */
    'signAssertion': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetSSOSettingsResponse
     */
    'requireSSO': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetSSOSettingsResponse
     */
    'useAlternateSSOID': boolean;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSSOSettingsResponse
     */
    'certificateName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSSOSettingsResponse
     */
    'certificateExpirationDate': string;
}
/**
 * 
 * @export
 * @interface QueriesGetServicesResponse
 */
export interface QueriesGetServicesResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetServicesResponse
     */
    'serviceID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetServicesResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetServicesResponse
     */
    'description': string;
    /**
     * 
     * @type {EnumerationsServiceType}
     * @memberof QueriesGetServicesResponse
     */
    'serviceTypeID': EnumerationsServiceType;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetServicesResponse
     */
    'active': boolean;
    /**
     * 
     * @type {Array<QueriesServicePermissionDTO>}
     * @memberof QueriesGetServicesResponse
     */
    'servicePermissions': Array<QueriesServicePermissionDTO>;
}


/**
 * 
 * @export
 * @interface QueriesGetSubdomainForUserResponse
 */
export interface QueriesGetSubdomainForUserResponse {
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetSubdomainForUserResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSubdomainForUserResponse
     */
    'subdomain': string;
}
/**
 * 
 * @export
 * @interface QueriesGetUserResponse
 */
export interface QueriesGetUserResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetUserResponse
     */
    'userID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetUserResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetUserResponse
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetUserResponse
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetUserResponse
     */
    'normalizedEmail': string;
    /**
     * 
     * @type {UserUserActiveStatus}
     * @memberof QueriesGetUserResponse
     */
    'activeStatus': UserUserActiveStatus;
    /**
     * 
     * @type {EnumerationsRole}
     * @memberof QueriesGetUserResponse
     */
    'roleID': EnumerationsRole;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetUserResponse
     */
    'clientID': string;
    /**
     * 
     * @type {Array<QueriesServiceLinesResponse>}
     * @memberof QueriesGetUserResponse
     */
    'serviceLines': Array<QueriesServiceLinesResponse>;
    /**
     * 
     * @type {Array<TransferObjectsPlanInfo>}
     * @memberof QueriesGetUserResponse
     */
    'plans': Array<TransferObjectsPlanInfo>;
    /**
     * 
     * @type {Array<TransferObjectsAnalysisInfo>}
     * @memberof QueriesGetUserResponse
     */
    'analyses': Array<TransferObjectsAnalysisInfo>;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetUserResponse
     */
    'isDefaultClient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetUserResponse
     */
    'isConsultant': boolean;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetUserResponse
     */
    'dropboxName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetUserResponse
     */
    'alternateSSOID': string;
    /**
     * 
     * @type {Array<TransferObjectsProjectInfo>}
     * @memberof QueriesGetUserResponse
     */
    'projects': Array<TransferObjectsProjectInfo>;
}


/**
 * 
 * @export
 * @interface QueriesGetWorksClientListResponse
 */
export interface QueriesGetWorksClientListResponse {
    /**
     * 
     * @type {number}
     * @memberof QueriesGetWorksClientListResponse
     */
    'rowCount': number;
    /**
     * 
     * @type {Array<QueriesWorksClientDTO>}
     * @memberof QueriesGetWorksClientListResponse
     */
    'rows': Array<QueriesWorksClientDTO>;
}
/**
 * 
 * @export
 * @interface QueriesPendingSupportAccess
 */
export interface QueriesPendingSupportAccess {
    /**
     * 
     * @type {string}
     * @memberof QueriesPendingSupportAccess
     */
    'supportAccessID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesPendingSupportAccess
     */
    'dateRequested': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesPendingSupportAccess
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesPendingSupportAccess
     */
    'requestedByName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesPendingSupportAccess
     */
    'requestedByEmail': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesPendingSupportAccess
     */
    'duration': number;
}
/**
 * 
 * @export
 * @interface QueriesProviderDTO
 */
export interface QueriesProviderDTO {
    /**
     * 
     * @type {number}
     * @memberof QueriesProviderDTO
     */
    'providerID': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesProviderDTO
     */
    'providerName': string;
}
/**
 * 
 * @export
 * @interface QueriesRequestSupportAccessCommand
 */
export interface QueriesRequestSupportAccessCommand {
    /**
     * 
     * @type {string}
     * @memberof QueriesRequestSupportAccessCommand
     */
    'clientID': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesRequestSupportAccessCommand
     */
    'duration': number;
}
/**
 * 
 * @export
 * @interface QueriesServiceDeliverablesUser
 */
export interface QueriesServiceDeliverablesUser {
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceDeliverablesUser
     */
    'userID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceDeliverablesUser
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceDeliverablesUser
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceDeliverablesUser
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface QueriesServiceLevelPermissionsResponse
 */
export interface QueriesServiceLevelPermissionsResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceLevelPermissionsResponse
     */
    'servicePermissionID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceLevelPermissionsResponse
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesServiceLevelPermissionsResponse
     */
    'active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesServiceLevelPermissionsResponse
     */
    'beta': boolean;
}
/**
 * 
 * @export
 * @interface QueriesServiceLinesResponse
 */
export interface QueriesServiceLinesResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceLinesResponse
     */
    'serviceID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceLinesResponse
     */
    'serviceName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceLinesResponse
     */
    'serviceDescription': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesServiceLinesResponse
     */
    'active': boolean;
    /**
     * 
     * @type {EnumerationsServiceType}
     * @memberof QueriesServiceLinesResponse
     */
    'serviceType': EnumerationsServiceType;
    /**
     * 
     * @type {Array<QueriesServiceLevelPermissionsResponse>}
     * @memberof QueriesServiceLinesResponse
     */
    'servicePermissions': Array<QueriesServiceLevelPermissionsResponse>;
}


/**
 * 
 * @export
 * @interface QueriesServicePermissionDTO
 */
export interface QueriesServicePermissionDTO {
    /**
     * 
     * @type {string}
     * @memberof QueriesServicePermissionDTO
     */
    'servicePermissionID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesServicePermissionDTO
     */
    'serviceID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesServicePermissionDTO
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface QueriesSupportAccessActiveOrPendingRequest
 */
export interface QueriesSupportAccessActiveOrPendingRequest {
    /**
     * 
     * @type {EnumerationsSupportAccessStatus}
     * @memberof QueriesSupportAccessActiveOrPendingRequest
     */
    'status': EnumerationsSupportAccessStatus;
    /**
     * 
     * @type {string}
     * @memberof QueriesSupportAccessActiveOrPendingRequest
     */
    'dateExpired'?: string | null;
}


/**
 * 
 * @export
 * @interface QueriesSupportAccessHistoryDates
 */
export interface QueriesSupportAccessHistoryDates {
    /**
     * 
     * @type {string}
     * @memberof QueriesSupportAccessHistoryDates
     */
    'dateStarted'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesSupportAccessHistoryDates
     */
    'dateExpired'?: string | null;
}
/**
 * 
 * @export
 * @interface QueriesSupportInfoResponse
 */
export interface QueriesSupportInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesSupportInfoResponse
     */
    'productSupportEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesSupportInfoResponse
     */
    'productSupportPhone'?: string | null;
}
/**
 * 
 * @export
 * @interface QueriesUserServiceDTO
 */
export interface QueriesUserServiceDTO {
    /**
     * 
     * @type {string}
     * @memberof QueriesUserServiceDTO
     */
    'serviceID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesUserServiceDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesUserServiceDTO
     */
    'description': string;
    /**
     * 
     * @type {EnumerationsServiceType}
     * @memberof QueriesUserServiceDTO
     */
    'serviceType': EnumerationsServiceType;
}


/**
 * 
 * @export
 * @interface QueriesUserToViewAs
 */
export interface QueriesUserToViewAs {
    /**
     * 
     * @type {string}
     * @memberof QueriesUserToViewAs
     */
    'userID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesUserToViewAs
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesUserToViewAs
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesUserToViewAs
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface QueriesWorksClientDTO
 */
export interface QueriesWorksClientDTO {
    /**
     * 
     * @type {number}
     * @memberof QueriesWorksClientDTO
     */
    'clientID': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesWorksClientDTO
     */
    'clientName': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesWorksClientDTO
     */
    'aapServicesClient': boolean;
}
/**
 * 
 * @export
 * @interface SupportAccessDurationDTO
 */
export interface SupportAccessDurationDTO {
    /**
     * 
     * @type {string}
     * @memberof SupportAccessDurationDTO
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof SupportAccessDurationDTO
     */
    'duration': number;
}
/**
 * 
 * @export
 * @interface SupportAccessPreviousAccessDTO
 */
export interface SupportAccessPreviousAccessDTO {
    /**
     * 
     * @type {string}
     * @memberof SupportAccessPreviousAccessDTO
     */
    'supportAccessID': string;
    /**
     * 
     * @type {string}
     * @memberof SupportAccessPreviousAccessDTO
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof SupportAccessPreviousAccessDTO
     */
    'lastActive': string;
}
/**
 * 
 * @export
 * @interface SupportAccessSupportAccessHistoryDTO
 */
export interface SupportAccessSupportAccessHistoryDTO {
    /**
     * 
     * @type {string}
     * @memberof SupportAccessSupportAccessHistoryDTO
     */
    'actionDate': string;
    /**
     * 
     * @type {string}
     * @memberof SupportAccessSupportAccessHistoryDTO
     */
    'actionPerformed': string;
    /**
     * 
     * @type {string}
     * @memberof SupportAccessSupportAccessHistoryDTO
     */
    'performedByUser': string;
    /**
     * 
     * @type {string}
     * @memberof SupportAccessSupportAccessHistoryDTO
     */
    'performedByEmail': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsAnalysisInfo
 */
export interface TransferObjectsAnalysisInfo {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAnalysisInfo
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAnalysisInfo
     */
    'dateCreated': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAnalysisInfo
     */
    'analysisName': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsPlanInfo
 */
export interface TransferObjectsPlanInfo {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'planIdentifier': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'planDate': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'planName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'planCode': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'publishDate': string;
    /**
     * 
     * @type {EnumerationsPlanType}
     * @memberof TransferObjectsPlanInfo
     */
    'planType': EnumerationsPlanType;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsPlanInfo
     */
    'updatePlan': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'reportLastAccessed'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsPlanInfo
     */
    'ipedsSchedule': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsPlanInfo
     */
    'isPublished': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsPlanInfo
     */
    'underAudit': boolean;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsPlanInfo
     */
    'aapPlanID': number;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'actionOrientedProgramLastAccessed'?: string | null;
    /**
     * 
     * @type {EnumerationsComplianceType}
     * @memberof TransferObjectsPlanInfo
     */
    'complianceTypeID': EnumerationsComplianceType;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'gfeAssessmentLastAccessed'?: string | null;
}


/**
 * 
 * @export
 * @interface TransferObjectsProjectInfo
 */
export interface TransferObjectsProjectInfo {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectInfo
     */
    'projectID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectInfo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectInfo
     */
    'snapshotDate': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsResponseDTO
 */
export interface TransferObjectsResponseDTO {
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsResponseDTO
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsResponseDTO
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface UserAvailableUser
 */
export interface UserAvailableUser {
    /**
     * 
     * @type {string}
     * @memberof UserAvailableUser
     */
    'userID': string;
    /**
     * 
     * @type {string}
     * @memberof UserAvailableUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserAvailableUser
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface UserCreateUserResponse
 */
export interface UserCreateUserResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UserCreateUserResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateUserResponse
     */
    'userID': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserCreateUserResponse
     */
    'domainValidationError': boolean;
}
/**
 * 
 * @export
 * @interface UserGetUserFromEmailResponseDTO
 */
export interface UserGetUserFromEmailResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof UserGetUserFromEmailResponseDTO
     */
    'userID': string;
    /**
     * 
     * @type {string}
     * @memberof UserGetUserFromEmailResponseDTO
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserGetUserFromEmailResponseDTO
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UserGetUserFromEmailResponseDTO
     */
    'lastName': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGetUserFromEmailResponseDTO
     */
    'isUserActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGetUserFromEmailResponseDTO
     */
    'hasCompletedAccountRegistration': boolean;
    /**
     * 
     * @type {EnumerationsRole}
     * @memberof UserGetUserFromEmailResponseDTO
     */
    'roleID': EnumerationsRole;
    /**
     * 
     * @type {UserUserActiveStatus}
     * @memberof UserGetUserFromEmailResponseDTO
     */
    'activeStatus': UserUserActiveStatus;
    /**
     * 
     * @type {boolean}
     * @memberof UserGetUserFromEmailResponseDTO
     */
    'existsForCurrentClient': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserGetUserFromEmailResponseDTO
     */
    'defaultClientName': string;
    /**
     * 
     * @type {string}
     * @memberof UserGetUserFromEmailResponseDTO
     */
    'dropboxName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserGetUserFromEmailResponseDTO
     */
    'isConsultant': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGetUserFromEmailResponseDTO
     */
    'canEditUsersInfo': boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const UserManageUsersSortColumn = {
    UserName: 1,
    Email: 2,
    ServiceLines: 3,
    Status: 4,
    Role: 5
} as const;

export type UserManageUsersSortColumn = typeof UserManageUsersSortColumn[keyof typeof UserManageUsersSortColumn];


/**
 * 
 * @export
 * @enum {string}
 */

export const UserUserActiveStatus = {
    Active: 1,
    Inactive: 2,
    Pending: 3
} as const;

export type UserUserActiveStatus = typeof UserUserActiveStatus[keyof typeof UserUserActiveStatus];



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CommandsAdminChangePasswordCommand} [commandsAdminChangePasswordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthAdminChangePasswordPut: async (commandsAdminChangePasswordCommand?: CommandsAdminChangePasswordCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Auth/admin-change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsAdminChangePasswordCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsChangePasswordCommand} [commandsChangePasswordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthChangePasswordPut: async (commandsChangePasswordCommand?: CommandsChangePasswordCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Auth/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsChangePasswordCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsChangeExpiredPasswordRequest} [commandsChangeExpiredPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthExpiredPasswordPut: async (commandsChangeExpiredPasswordRequest?: CommandsChangeExpiredPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Auth/expired-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsChangeExpiredPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthForgotPasswordPost: async (body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Auth/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsLoginCommand} [commandsLoginCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthLoginPost: async (commandsLoginCommand?: CommandsLoginCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsLoginCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthLogoutPost: async (body?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthMeGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Auth/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {boolean} fromSSO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthMfaCodeFromSsoFromSSOPost: async (code: string, fromSSO: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('apiIdentityAuthMfaCodeFromSsoFromSSOPost', 'code', code)
            // verify required parameter 'fromSSO' is not null or undefined
            assertParamExists('apiIdentityAuthMfaCodeFromSsoFromSSOPost', 'fromSSO', fromSSO)
            const localVarPath = `/api/identity/Auth/mfa/{code}/from-sso/{fromSSO}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"fromSSO"}}`, encodeURIComponent(String(fromSSO)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AuthenticationResetPasswordDTO} [authenticationResetPasswordDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthNewUserPasswordPut: async (authenticationResetPasswordDTO?: AuthenticationResetPasswordDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Auth/new-user-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authenticationResetPasswordDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthQrGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Auth/qr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthRequestNewLinkPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Auth/request-new-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthRequestRegistrationLinkPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Auth/request-registration-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AuthenticationResetPasswordDTO} [authenticationResetPasswordDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthResetPasswordPut: async (authenticationResetPasswordDTO?: AuthenticationResetPasswordDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authenticationResetPasswordDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthTimeBeforeExpirationGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Auth/time-before-expiration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthTimeoutWarningGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Auth/timeout-warning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CommandsAdminChangePasswordCommand} [commandsAdminChangePasswordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthAdminChangePasswordPut(commandsAdminChangePasswordCommand?: CommandsAdminChangePasswordCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthAdminChangePasswordPut(commandsAdminChangePasswordCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthAdminChangePasswordPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsChangePasswordCommand} [commandsChangePasswordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthChangePasswordPut(commandsChangePasswordCommand?: CommandsChangePasswordCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthChangePasswordPut(commandsChangePasswordCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthChangePasswordPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsChangeExpiredPasswordRequest} [commandsChangeExpiredPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthExpiredPasswordPut(commandsChangeExpiredPasswordRequest?: CommandsChangeExpiredPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthExpiredPasswordPut(commandsChangeExpiredPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthExpiredPasswordPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthForgotPasswordPost(body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthForgotPasswordPost(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthForgotPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsLoginCommand} [commandsLoginCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthLoginPost(commandsLoginCommand?: CommandsLoginCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsLoginResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthLoginPost(commandsLoginCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthLogoutPost(body?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationLogoutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthLogoutPost(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthLogoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthMeGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetLoggedInUserDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthMeGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {boolean} fromSSO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthMfaCodeFromSsoFromSSOPost(code: string, fromSSO: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsMFALoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthMfaCodeFromSsoFromSSOPost(code, fromSSO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthMfaCodeFromSsoFromSSOPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AuthenticationResetPasswordDTO} [authenticationResetPasswordDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthNewUserPasswordPut(authenticationResetPasswordDTO?: AuthenticationResetPasswordDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthNewUserPasswordPut(authenticationResetPasswordDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthNewUserPasswordPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthQrGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthQrGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthQrGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthRequestNewLinkPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthRequestNewLinkPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthRequestNewLinkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthRequestRegistrationLinkPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthRequestRegistrationLinkPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthRequestRegistrationLinkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AuthenticationResetPasswordDTO} [authenticationResetPasswordDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthResetPasswordPut(authenticationResetPasswordDTO?: AuthenticationResetPasswordDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthResetPasswordPut(authenticationResetPasswordDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthResetPasswordPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthTimeBeforeExpirationGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthTimeBeforeExpirationGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthTimeBeforeExpirationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAuthTimeoutWarningGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAuthTimeoutWarningGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.apiIdentityAuthTimeoutWarningGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @param {CommandsAdminChangePasswordCommand} [commandsAdminChangePasswordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthAdminChangePasswordPut(commandsAdminChangePasswordCommand?: CommandsAdminChangePasswordCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityAuthAdminChangePasswordPut(commandsAdminChangePasswordCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsChangePasswordCommand} [commandsChangePasswordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthChangePasswordPut(commandsChangePasswordCommand?: CommandsChangePasswordCommand, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentityAuthChangePasswordPut(commandsChangePasswordCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsChangeExpiredPasswordRequest} [commandsChangeExpiredPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthExpiredPasswordPut(commandsChangeExpiredPasswordRequest?: CommandsChangeExpiredPasswordRequest, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentityAuthExpiredPasswordPut(commandsChangeExpiredPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthForgotPasswordPost(body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiIdentityAuthForgotPasswordPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsLoginCommand} [commandsLoginCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthLoginPost(commandsLoginCommand?: CommandsLoginCommand, options?: any): AxiosPromise<CommandsLoginResponseDTO> {
            return localVarFp.apiIdentityAuthLoginPost(commandsLoginCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthLogoutPost(body?: number, options?: any): AxiosPromise<AuthenticationLogoutResponse> {
            return localVarFp.apiIdentityAuthLogoutPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthMeGet(options?: any): AxiosPromise<QueriesGetLoggedInUserDataResponse> {
            return localVarFp.apiIdentityAuthMeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {boolean} fromSSO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthMfaCodeFromSsoFromSSOPost(code: string, fromSSO: boolean, options?: any): AxiosPromise<CommandsMFALoginResponse> {
            return localVarFp.apiIdentityAuthMfaCodeFromSsoFromSSOPost(code, fromSSO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthenticationResetPasswordDTO} [authenticationResetPasswordDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthNewUserPasswordPut(authenticationResetPasswordDTO?: AuthenticationResetPasswordDTO, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentityAuthNewUserPasswordPut(authenticationResetPasswordDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthQrGet(options?: any): AxiosPromise<string> {
            return localVarFp.apiIdentityAuthQrGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthRequestNewLinkPost(options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentityAuthRequestNewLinkPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthRequestRegistrationLinkPost(options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentityAuthRequestRegistrationLinkPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthenticationResetPasswordDTO} [authenticationResetPasswordDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthResetPasswordPut(authenticationResetPasswordDTO?: AuthenticationResetPasswordDTO, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentityAuthResetPasswordPut(authenticationResetPasswordDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthTimeBeforeExpirationGet(options?: any): AxiosPromise<string> {
            return localVarFp.apiIdentityAuthTimeBeforeExpirationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAuthTimeoutWarningGet(options?: any): AxiosPromise<boolean> {
            return localVarFp.apiIdentityAuthTimeoutWarningGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @param {CommandsAdminChangePasswordCommand} [commandsAdminChangePasswordCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthAdminChangePasswordPut(commandsAdminChangePasswordCommand?: CommandsAdminChangePasswordCommand, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthAdminChangePasswordPut(commandsAdminChangePasswordCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsChangePasswordCommand} [commandsChangePasswordCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthChangePasswordPut(commandsChangePasswordCommand?: CommandsChangePasswordCommand, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthChangePasswordPut(commandsChangePasswordCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsChangeExpiredPasswordRequest} [commandsChangeExpiredPasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthExpiredPasswordPut(commandsChangeExpiredPasswordRequest?: CommandsChangeExpiredPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthExpiredPasswordPut(commandsChangeExpiredPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthForgotPasswordPost(body?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthForgotPasswordPost(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsLoginCommand} [commandsLoginCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthLoginPost(commandsLoginCommand?: CommandsLoginCommand, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthLoginPost(commandsLoginCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthLogoutPost(body?: number, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthLogoutPost(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthMeGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthMeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {boolean} fromSSO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthMfaCodeFromSsoFromSSOPost(code: string, fromSSO: boolean, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthMfaCodeFromSsoFromSSOPost(code, fromSSO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthenticationResetPasswordDTO} [authenticationResetPasswordDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthNewUserPasswordPut(authenticationResetPasswordDTO?: AuthenticationResetPasswordDTO, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthNewUserPasswordPut(authenticationResetPasswordDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthQrGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthQrGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthRequestNewLinkPost(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthRequestNewLinkPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthRequestRegistrationLinkPost(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthRequestRegistrationLinkPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthenticationResetPasswordDTO} [authenticationResetPasswordDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthResetPasswordPut(authenticationResetPasswordDTO?: AuthenticationResetPasswordDTO, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthResetPasswordPut(authenticationResetPasswordDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthTimeBeforeExpirationGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthTimeBeforeExpirationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public apiIdentityAuthTimeoutWarningGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).apiIdentityAuthTimeoutWarningGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientManagementApi - axios parameter creator
 * @export
 */
export const ClientManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementClientCreationGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/ClientManagement/client-creation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientID 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementClientIDAddEmailDomainPost: async (clientID: string, body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientID' is not null or undefined
            assertParamExists('apiIdentityClientManagementClientIDAddEmailDomainPost', 'clientID', clientID)
            const localVarPath = `/api/identity/ClientManagement/{clientID}/add-email-domain`
                .replace(`{${"clientID"}}`, encodeURIComponent(String(clientID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementClientIDDelete: async (clientID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientID' is not null or undefined
            assertParamExists('apiIdentityClientManagementClientIDDelete', 'clientID', clientID)
            const localVarPath = `/api/identity/ClientManagement/{clientID}`
                .replace(`{${"clientID"}}`, encodeURIComponent(String(clientID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementClientIDGet: async (clientID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientID' is not null or undefined
            assertParamExists('apiIdentityClientManagementClientIDGet', 'clientID', clientID)
            const localVarPath = `/api/identity/ClientManagement/{clientID}`
                .replace(`{${"clientID"}}`, encodeURIComponent(String(clientID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementClientIDGetLogoGet: async (clientID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientID' is not null or undefined
            assertParamExists('apiIdentityClientManagementClientIDGetLogoGet', 'clientID', clientID)
            const localVarPath = `/api/identity/ClientManagement/{clientID}/get-logo`
                .replace(`{${"clientID"}}`, encodeURIComponent(String(clientID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientID 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementClientIDSaveLogoPost: async (clientID: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientID' is not null or undefined
            assertParamExists('apiIdentityClientManagementClientIDSaveLogoPost', 'clientID', clientID)
            const localVarPath = `/api/identity/ClientManagement/{clientID}/save-logo`
                .replace(`{${"clientID"}}`, encodeURIComponent(String(clientID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementDefaultUserRoleGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/ClientManagement/default-user-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdateDefaultUserRoleCommand} [commandsUpdateDefaultUserRoleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementDefaultUserRolePut: async (commandsUpdateDefaultUserRoleCommand?: CommandsUpdateDefaultUserRoleCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/ClientManagement/default-user-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateDefaultUserRoleCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementDocumentCenterGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/ClientManagement/document-center`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {ClientManageClientsSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {boolean} [showInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementGet: async (searchTerm?: string, sortColumn?: ClientManageClientsSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, showInactive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/ClientManagement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (rowsPerPage !== undefined) {
                localVarQueryParameter['rowsPerPage'] = rowsPerPage;
            }

            if (showInactive !== undefined) {
                localVarQueryParameter['showInactive'] = showInactive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementGetWorksClientListGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/ClientManagement/get-works-client-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementMfaGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/ClientManagement/mfa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} mfaRequired 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementMfaMfaRequiredPut: async (mfaRequired: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mfaRequired' is not null or undefined
            assertParamExists('apiIdentityClientManagementMfaMfaRequiredPut', 'mfaRequired', mfaRequired)
            const localVarPath = `/api/identity/ClientManagement/mfa/{mfaRequired}`
                .replace(`{${"mfaRequired"}}`, encodeURIComponent(String(mfaRequired)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateClientCommand} [commandsCreateClientCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementPost: async (commandsCreateClientCommand?: CommandsCreateClientCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/ClientManagement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateClientCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdateClientCommand} [commandsUpdateClientCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementPut: async (commandsUpdateClientCommand?: CommandsUpdateClientCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/ClientManagement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateClientCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientManagementApi - functional programming interface
 * @export
 */
export const ClientManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementClientCreationGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetClientCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementClientCreationGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementClientCreationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientID 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementClientIDAddEmailDomainPost(clientID: string, body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementClientIDAddEmailDomainPost(clientID, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementClientIDAddEmailDomainPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementClientIDDelete(clientID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementClientIDDelete(clientID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementClientIDDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementClientIDGet(clientID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetClientEditResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementClientIDGet(clientID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementClientIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementClientIDGetLogoGet(clientID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementClientIDGetLogoGet(clientID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementClientIDGetLogoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientID 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementClientIDSaveLogoPost(clientID: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementClientIDSaveLogoPost(clientID, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementClientIDSaveLogoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementDefaultUserRoleGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelsRole>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementDefaultUserRoleGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementDefaultUserRoleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdateDefaultUserRoleCommand} [commandsUpdateDefaultUserRoleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementDefaultUserRolePut(commandsUpdateDefaultUserRoleCommand?: CommandsUpdateDefaultUserRoleCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsUpdateDefaultUserRoleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementDefaultUserRolePut(commandsUpdateDefaultUserRoleCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementDefaultUserRolePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementDocumentCenterGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientAvailableClient>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementDocumentCenterGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementDocumentCenterGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {ClientManageClientsSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {boolean} [showInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementGet(searchTerm?: string, sortColumn?: ClientManageClientsSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, showInactive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAllClientsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementGet(searchTerm, sortColumn, sortDirection, page, rowsPerPage, showInactive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementGetWorksClientListGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetWorksClientListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementGetWorksClientListGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementGetWorksClientListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementMfaGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementMfaGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementMfaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} mfaRequired 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementMfaMfaRequiredPut(mfaRequired: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementMfaMfaRequiredPut(mfaRequired, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementMfaMfaRequiredPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateClientCommand} [commandsCreateClientCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementPost(commandsCreateClientCommand?: CommandsCreateClientCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsCreateClientDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementPost(commandsCreateClientCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdateClientCommand} [commandsUpdateClientCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityClientManagementPut(commandsUpdateClientCommand?: CommandsUpdateClientCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityClientManagementPut(commandsUpdateClientCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientManagementApi.apiIdentityClientManagementPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientManagementApi - factory interface
 * @export
 */
export const ClientManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientManagementApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementClientCreationGet(options?: any): AxiosPromise<QueriesGetClientCreationResponse> {
            return localVarFp.apiIdentityClientManagementClientCreationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientID 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementClientIDAddEmailDomainPost(clientID: string, body?: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityClientManagementClientIDAddEmailDomainPost(clientID, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementClientIDDelete(clientID: string, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentityClientManagementClientIDDelete(clientID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementClientIDGet(clientID: string, options?: any): AxiosPromise<QueriesGetClientEditResponse> {
            return localVarFp.apiIdentityClientManagementClientIDGet(clientID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementClientIDGetLogoGet(clientID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityClientManagementClientIDGetLogoGet(clientID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientID 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementClientIDSaveLogoPost(clientID: string, file?: File, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentityClientManagementClientIDSaveLogoPost(clientID, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementDefaultUserRoleGet(options?: any): AxiosPromise<ModelsRole> {
            return localVarFp.apiIdentityClientManagementDefaultUserRoleGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdateDefaultUserRoleCommand} [commandsUpdateDefaultUserRoleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementDefaultUserRolePut(commandsUpdateDefaultUserRoleCommand?: CommandsUpdateDefaultUserRoleCommand, options?: any): AxiosPromise<CommandsUpdateDefaultUserRoleResponse> {
            return localVarFp.apiIdentityClientManagementDefaultUserRolePut(commandsUpdateDefaultUserRoleCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementDocumentCenterGet(options?: any): AxiosPromise<Array<ClientAvailableClient>> {
            return localVarFp.apiIdentityClientManagementDocumentCenterGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {ClientManageClientsSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {boolean} [showInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementGet(searchTerm?: string, sortColumn?: ClientManageClientsSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, showInactive?: boolean, options?: any): AxiosPromise<QueriesGetAllClientsResponse> {
            return localVarFp.apiIdentityClientManagementGet(searchTerm, sortColumn, sortDirection, page, rowsPerPage, showInactive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementGetWorksClientListGet(options?: any): AxiosPromise<QueriesGetWorksClientListResponse> {
            return localVarFp.apiIdentityClientManagementGetWorksClientListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementMfaGet(options?: any): AxiosPromise<boolean> {
            return localVarFp.apiIdentityClientManagementMfaGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} mfaRequired 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementMfaMfaRequiredPut(mfaRequired: boolean, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityClientManagementMfaMfaRequiredPut(mfaRequired, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateClientCommand} [commandsCreateClientCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementPost(commandsCreateClientCommand?: CommandsCreateClientCommand, options?: any): AxiosPromise<CommandsCreateClientDTO> {
            return localVarFp.apiIdentityClientManagementPost(commandsCreateClientCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdateClientCommand} [commandsUpdateClientCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityClientManagementPut(commandsUpdateClientCommand?: CommandsUpdateClientCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiIdentityClientManagementPut(commandsUpdateClientCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientManagementApi - object-oriented interface
 * @export
 * @class ClientManagementApi
 * @extends {BaseAPI}
 */
export class ClientManagementApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementClientCreationGet(options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementClientCreationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientID 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementClientIDAddEmailDomainPost(clientID: string, body?: string, options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementClientIDAddEmailDomainPost(clientID, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementClientIDDelete(clientID: string, options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementClientIDDelete(clientID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementClientIDGet(clientID: string, options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementClientIDGet(clientID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementClientIDGetLogoGet(clientID: string, options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementClientIDGetLogoGet(clientID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientID 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementClientIDSaveLogoPost(clientID: string, file?: File, options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementClientIDSaveLogoPost(clientID, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementDefaultUserRoleGet(options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementDefaultUserRoleGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdateDefaultUserRoleCommand} [commandsUpdateDefaultUserRoleCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementDefaultUserRolePut(commandsUpdateDefaultUserRoleCommand?: CommandsUpdateDefaultUserRoleCommand, options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementDefaultUserRolePut(commandsUpdateDefaultUserRoleCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementDocumentCenterGet(options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementDocumentCenterGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [searchTerm] 
     * @param {ClientManageClientsSortColumn} [sortColumn] 
     * @param {EnumerationsSortDirection} [sortDirection] 
     * @param {number} [page] 
     * @param {number} [rowsPerPage] 
     * @param {boolean} [showInactive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementGet(searchTerm?: string, sortColumn?: ClientManageClientsSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, showInactive?: boolean, options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementGet(searchTerm, sortColumn, sortDirection, page, rowsPerPage, showInactive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementGetWorksClientListGet(options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementGetWorksClientListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementMfaGet(options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementMfaGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} mfaRequired 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementMfaMfaRequiredPut(mfaRequired: boolean, options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementMfaMfaRequiredPut(mfaRequired, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateClientCommand} [commandsCreateClientCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementPost(commandsCreateClientCommand?: CommandsCreateClientCommand, options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementPost(commandsCreateClientCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdateClientCommand} [commandsUpdateClientCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientManagementApi
     */
    public apiIdentityClientManagementPut(commandsUpdateClientCommand?: CommandsUpdateClientCommand, options?: RawAxiosRequestConfig) {
        return ClientManagementApiFp(this.configuration).apiIdentityClientManagementPut(commandsUpdateClientCommand, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailApi - axios parameter creator
 * @export
 */
export const EmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityEmailWfaShareTemplateGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Email/wfa-share-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailApi - functional programming interface
 * @export
 */
export const EmailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityEmailWfaShareTemplateGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetEmailTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityEmailWfaShareTemplateGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailApi.apiIdentityEmailWfaShareTemplateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailApi - factory interface
 * @export
 */
export const EmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityEmailWfaShareTemplateGet(options?: any): AxiosPromise<QueriesGetEmailTemplateResponse> {
            return localVarFp.apiIdentityEmailWfaShareTemplateGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailApi - object-oriented interface
 * @export
 * @class EmailApi
 * @extends {BaseAPI}
 */
export class EmailApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    public apiIdentityEmailWfaShareTemplateGet(options?: RawAxiosRequestConfig) {
        return EmailApiFp(this.configuration).apiIdentityEmailWfaShareTemplateGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RequestSupportApi - axios parameter creator
 * @export
 */
export const RequestSupportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [contactMethod] 
         * @param {string} [consultantUserID] 
         * @param {string} [description] 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRequestSupportPost: async (contactMethod?: string, consultantUserID?: string, description?: string, attachments?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/RequestSupport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (contactMethod !== undefined) { 
                localVarFormParams.append('contactMethod', contactMethod as any);
            }
    
            if (consultantUserID !== undefined) { 
                localVarFormParams.append('consultantUserID', consultantUserID as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
                if (attachments) {
                attachments.forEach((element) => {
                    localVarFormParams.append('attachments', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRequestSupportSupportInfoGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/RequestSupport/support-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RequestSupportApi - functional programming interface
 * @export
 */
export const RequestSupportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RequestSupportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [contactMethod] 
         * @param {string} [consultantUserID] 
         * @param {string} [description] 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRequestSupportPost(contactMethod?: string, consultantUserID?: string, description?: string, attachments?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRequestSupportPost(contactMethod, consultantUserID, description, attachments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequestSupportApi.apiIdentityRequestSupportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRequestSupportSupportInfoGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesSupportInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRequestSupportSupportInfoGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequestSupportApi.apiIdentityRequestSupportSupportInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RequestSupportApi - factory interface
 * @export
 */
export const RequestSupportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RequestSupportApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [contactMethod] 
         * @param {string} [consultantUserID] 
         * @param {string} [description] 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRequestSupportPost(contactMethod?: string, consultantUserID?: string, description?: string, attachments?: Array<File>, options?: any): AxiosPromise<void> {
            return localVarFp.apiIdentityRequestSupportPost(contactMethod, consultantUserID, description, attachments, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRequestSupportSupportInfoGet(options?: any): AxiosPromise<QueriesSupportInfoResponse> {
            return localVarFp.apiIdentityRequestSupportSupportInfoGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RequestSupportApi - object-oriented interface
 * @export
 * @class RequestSupportApi
 * @extends {BaseAPI}
 */
export class RequestSupportApi extends BaseAPI {
    /**
     * 
     * @param {string} [contactMethod] 
     * @param {string} [consultantUserID] 
     * @param {string} [description] 
     * @param {Array<File>} [attachments] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestSupportApi
     */
    public apiIdentityRequestSupportPost(contactMethod?: string, consultantUserID?: string, description?: string, attachments?: Array<File>, options?: RawAxiosRequestConfig) {
        return RequestSupportApiFp(this.configuration).apiIdentityRequestSupportPost(contactMethod, consultantUserID, description, attachments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestSupportApi
     */
    public apiIdentityRequestSupportSupportInfoGet(options?: RawAxiosRequestConfig) {
        return RequestSupportApiFp(this.configuration).apiIdentityRequestSupportSupportInfoGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RoutingApi - axios parameter creator
 * @export
 */
export const RoutingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRoutingFirstGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Routing/first`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoutingApi - functional programming interface
 * @export
 */
export const RoutingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoutingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRoutingFirstGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnumerationsFirstRoute>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRoutingFirstGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoutingApi.apiIdentityRoutingFirstGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RoutingApi - factory interface
 * @export
 */
export const RoutingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoutingApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRoutingFirstGet(options?: any): AxiosPromise<EnumerationsFirstRoute> {
            return localVarFp.apiIdentityRoutingFirstGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoutingApi - object-oriented interface
 * @export
 * @class RoutingApi
 * @extends {BaseAPI}
 */
export class RoutingApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutingApi
     */
    public apiIdentityRoutingFirstGet(options?: RawAxiosRequestConfig) {
        return RoutingApiFp(this.configuration).apiIdentityRoutingFirstGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SSOApi - axios parameter creator
 * @export
 */
export const SSOApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {File} [certificate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOCertificatePost: async (certificate?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SSO/certificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (certificate !== undefined) { 
                localVarFormParams.append('certificate', certificate as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOClientSsoInfoGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SSO/client-sso-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSODelete: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SSO`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSODownloadPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SSO/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SSO`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [application] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOInitiateLoginGet: async (application?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SSO/initiate-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (application !== undefined) {
                localVarQueryParameter['application'] = application;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOOnGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SSO/on`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsSaveSSOSettingsRequest} [commandsSaveSSOSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOPost: async (commandsSaveSSOSettingsRequest?: CommandsSaveSSOSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SSO`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsSaveSSOSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ssoSettingsID 
         * @param {string} [application] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOSsoSettingsIDPost: async (ssoSettingsID: string, application?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ssoSettingsID' is not null or undefined
            assertParamExists('apiIdentitySSOSsoSettingsIDPost', 'ssoSettingsID', ssoSettingsID)
            const localVarPath = `/api/identity/SSO/{ssoSettingsID}`
                .replace(`{${"ssoSettingsID"}}`, encodeURIComponent(String(ssoSettingsID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (application !== undefined) {
                localVarQueryParameter['application'] = application;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOUploadPost: async (file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SSO/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SSOApi - functional programming interface
 * @export
 */
export const SSOApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SSOApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {File} [certificate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySSOCertificatePost(certificate?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsUploadCertificateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySSOCertificatePost(certificate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiIdentitySSOCertificatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySSOClientSsoInfoGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesClientSSOInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySSOClientSsoInfoGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiIdentitySSOClientSsoInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySSODelete(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySSODelete(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiIdentitySSODelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySSODownloadPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySSODownloadPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiIdentitySSODownloadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySSOGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetSSOSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySSOGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiIdentitySSOGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [application] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySSOInitiateLoginGet(application?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySSOInitiateLoginGet(application, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiIdentitySSOInitiateLoginGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySSOOnGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetSSOOnResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySSOOnGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiIdentitySSOOnGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsSaveSSOSettingsRequest} [commandsSaveSSOSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySSOPost(commandsSaveSSOSettingsRequest?: CommandsSaveSSOSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySSOPost(commandsSaveSSOSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiIdentitySSOPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} ssoSettingsID 
         * @param {string} [application] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySSOSsoSettingsIDPost(ssoSettingsID: string, application?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySSOSsoSettingsIDPost(ssoSettingsID, application, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiIdentitySSOSsoSettingsIDPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySSOUploadPost(file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsUploadMetadataFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySSOUploadPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiIdentitySSOUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SSOApi - factory interface
 * @export
 */
export const SSOApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SSOApiFp(configuration)
    return {
        /**
         * 
         * @param {File} [certificate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOCertificatePost(certificate?: File, options?: any): AxiosPromise<CommandsUploadCertificateResponse> {
            return localVarFp.apiIdentitySSOCertificatePost(certificate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOClientSsoInfoGet(options?: any): AxiosPromise<QueriesClientSSOInfo> {
            return localVarFp.apiIdentitySSOClientSsoInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSODelete(options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentitySSODelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSODownloadPost(options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentitySSODownloadPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOGet(options?: any): AxiosPromise<QueriesGetSSOSettingsResponse> {
            return localVarFp.apiIdentitySSOGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [application] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOInitiateLoginGet(application?: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentitySSOInitiateLoginGet(application, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOOnGet(options?: any): AxiosPromise<QueriesGetSSOOnResponse> {
            return localVarFp.apiIdentitySSOOnGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsSaveSSOSettingsRequest} [commandsSaveSSOSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOPost(commandsSaveSSOSettingsRequest?: CommandsSaveSSOSettingsRequest, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentitySSOPost(commandsSaveSSOSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} ssoSettingsID 
         * @param {string} [application] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOSsoSettingsIDPost(ssoSettingsID: string, application?: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentitySSOSsoSettingsIDPost(ssoSettingsID, application, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySSOUploadPost(file?: File, options?: any): AxiosPromise<CommandsUploadMetadataFileResponse> {
            return localVarFp.apiIdentitySSOUploadPost(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SSOApi - object-oriented interface
 * @export
 * @class SSOApi
 * @extends {BaseAPI}
 */
export class SSOApi extends BaseAPI {
    /**
     * 
     * @param {File} [certificate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSOApi
     */
    public apiIdentitySSOCertificatePost(certificate?: File, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiIdentitySSOCertificatePost(certificate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSOApi
     */
    public apiIdentitySSOClientSsoInfoGet(options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiIdentitySSOClientSsoInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSOApi
     */
    public apiIdentitySSODelete(options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiIdentitySSODelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSOApi
     */
    public apiIdentitySSODownloadPost(options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiIdentitySSODownloadPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSOApi
     */
    public apiIdentitySSOGet(options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiIdentitySSOGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [application] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSOApi
     */
    public apiIdentitySSOInitiateLoginGet(application?: string, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiIdentitySSOInitiateLoginGet(application, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSOApi
     */
    public apiIdentitySSOOnGet(options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiIdentitySSOOnGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsSaveSSOSettingsRequest} [commandsSaveSSOSettingsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSOApi
     */
    public apiIdentitySSOPost(commandsSaveSSOSettingsRequest?: CommandsSaveSSOSettingsRequest, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiIdentitySSOPost(commandsSaveSSOSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} ssoSettingsID 
     * @param {string} [application] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSOApi
     */
    public apiIdentitySSOSsoSettingsIDPost(ssoSettingsID: string, application?: string, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiIdentitySSOSsoSettingsIDPost(ssoSettingsID, application, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSOApi
     */
    public apiIdentitySSOUploadPost(file?: File, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiIdentitySSOUploadPost(file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SupportAccessApi - axios parameter creator
 * @export
 */
export const SupportAccessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessActiveAccessGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SupportAccess/active-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesGetAdminsForClientQuery} [queriesGetAdminsForClientQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessClientAdminsGet: async (queriesGetAdminsForClientQuery?: QueriesGetAdminsForClientQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SupportAccess/client-admins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetAdminsForClientQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessClientHistoryGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SupportAccess/client-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessClientsAndDurationGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SupportAccess/clients-and-duration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessDenyAccessPut: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SupportAccess/deny-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessGrantAccessPut: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SupportAccess/grant-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessPendingRequestsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SupportAccess/pending-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessPreviousAccessGet: async (searchTerm?: string, page?: number, rowsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SupportAccess/previous-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (rowsPerPage !== undefined) {
                localVarQueryParameter['rowsPerPage'] = rowsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesRequestSupportAccessCommand} [queriesRequestSupportAccessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessRequestAccessPost: async (queriesRequestSupportAccessCommand?: QueriesRequestSupportAccessCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SupportAccess/request-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesRequestSupportAccessCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessRevokeAccessPut: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/SupportAccess/revoke-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} supportAccessID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessSupportAccessIDCancelAccessPut: async (supportAccessID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supportAccessID' is not null or undefined
            assertParamExists('apiIdentitySupportAccessSupportAccessIDCancelAccessPut', 'supportAccessID', supportAccessID)
            const localVarPath = `/api/identity/SupportAccess/{supportAccessID}/cancel-access`
                .replace(`{${"supportAccessID"}}`, encodeURIComponent(String(supportAccessID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} supportAccessID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessSupportAccessIDHistoryGet: async (supportAccessID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supportAccessID' is not null or undefined
            assertParamExists('apiIdentitySupportAccessSupportAccessIDHistoryGet', 'supportAccessID', supportAccessID)
            const localVarPath = `/api/identity/SupportAccess/{supportAccessID}/history`
                .replace(`{${"supportAccessID"}}`, encodeURIComponent(String(supportAccessID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} supportAccessID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessSupportAccessIDRemoveAccessPut: async (supportAccessID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supportAccessID' is not null or undefined
            assertParamExists('apiIdentitySupportAccessSupportAccessIDRemoveAccessPut', 'supportAccessID', supportAccessID)
            const localVarPath = `/api/identity/SupportAccess/{supportAccessID}/remove-access`
                .replace(`{${"supportAccessID"}}`, encodeURIComponent(String(supportAccessID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupportAccessApi - functional programming interface
 * @export
 */
export const SupportAccessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupportAccessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySupportAccessActiveAccessGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetActiveSupportAccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySupportAccessActiveAccessGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAccessApi.apiIdentitySupportAccessActiveAccessGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesGetAdminsForClientQuery} [queriesGetAdminsForClientQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySupportAccessClientAdminsGet(queriesGetAdminsForClientQuery?: QueriesGetAdminsForClientQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserAvailableUser>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySupportAccessClientAdminsGet(queriesGetAdminsForClientQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAccessApi.apiIdentitySupportAccessClientAdminsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySupportAccessClientHistoryGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetClientSupportAccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySupportAccessClientHistoryGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAccessApi.apiIdentitySupportAccessClientHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySupportAccessClientsAndDurationGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetClientAndDurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySupportAccessClientsAndDurationGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAccessApi.apiIdentitySupportAccessClientsAndDurationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySupportAccessDenyAccessPut(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySupportAccessDenyAccessPut(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAccessApi.apiIdentitySupportAccessDenyAccessPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySupportAccessGrantAccessPut(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySupportAccessGrantAccessPut(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAccessApi.apiIdentitySupportAccessGrantAccessPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySupportAccessPendingRequestsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetPendingSupportAccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySupportAccessPendingRequestsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAccessApi.apiIdentitySupportAccessPendingRequestsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySupportAccessPreviousAccessGet(searchTerm?: string, page?: number, rowsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetPreviousAccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySupportAccessPreviousAccessGet(searchTerm, page, rowsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAccessApi.apiIdentitySupportAccessPreviousAccessGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesRequestSupportAccessCommand} [queriesRequestSupportAccessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySupportAccessRequestAccessPost(queriesRequestSupportAccessCommand?: QueriesRequestSupportAccessCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySupportAccessRequestAccessPost(queriesRequestSupportAccessCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAccessApi.apiIdentitySupportAccessRequestAccessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySupportAccessRevokeAccessPut(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySupportAccessRevokeAccessPut(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAccessApi.apiIdentitySupportAccessRevokeAccessPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} supportAccessID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySupportAccessSupportAccessIDCancelAccessPut(supportAccessID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySupportAccessSupportAccessIDCancelAccessPut(supportAccessID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAccessApi.apiIdentitySupportAccessSupportAccessIDCancelAccessPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} supportAccessID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySupportAccessSupportAccessIDHistoryGet(supportAccessID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupportAccessSupportAccessHistoryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySupportAccessSupportAccessIDHistoryGet(supportAccessID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAccessApi.apiIdentitySupportAccessSupportAccessIDHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} supportAccessID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentitySupportAccessSupportAccessIDRemoveAccessPut(supportAccessID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentitySupportAccessSupportAccessIDRemoveAccessPut(supportAccessID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportAccessApi.apiIdentitySupportAccessSupportAccessIDRemoveAccessPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupportAccessApi - factory interface
 * @export
 */
export const SupportAccessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupportAccessApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessActiveAccessGet(options?: any): AxiosPromise<QueriesGetActiveSupportAccessResponse> {
            return localVarFp.apiIdentitySupportAccessActiveAccessGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesGetAdminsForClientQuery} [queriesGetAdminsForClientQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessClientAdminsGet(queriesGetAdminsForClientQuery?: QueriesGetAdminsForClientQuery, options?: any): AxiosPromise<Array<UserAvailableUser>> {
            return localVarFp.apiIdentitySupportAccessClientAdminsGet(queriesGetAdminsForClientQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessClientHistoryGet(options?: any): AxiosPromise<QueriesGetClientSupportAccessResponse> {
            return localVarFp.apiIdentitySupportAccessClientHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessClientsAndDurationGet(options?: any): AxiosPromise<QueriesGetClientAndDurationResponse> {
            return localVarFp.apiIdentitySupportAccessClientsAndDurationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessDenyAccessPut(options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentitySupportAccessDenyAccessPut(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessGrantAccessPut(options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentitySupportAccessGrantAccessPut(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessPendingRequestsGet(options?: any): AxiosPromise<QueriesGetPendingSupportAccessResponse> {
            return localVarFp.apiIdentitySupportAccessPendingRequestsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessPreviousAccessGet(searchTerm?: string, page?: number, rowsPerPage?: number, options?: any): AxiosPromise<QueriesGetPreviousAccessResponse> {
            return localVarFp.apiIdentitySupportAccessPreviousAccessGet(searchTerm, page, rowsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesRequestSupportAccessCommand} [queriesRequestSupportAccessCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessRequestAccessPost(queriesRequestSupportAccessCommand?: QueriesRequestSupportAccessCommand, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentitySupportAccessRequestAccessPost(queriesRequestSupportAccessCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessRevokeAccessPut(options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentitySupportAccessRevokeAccessPut(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} supportAccessID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessSupportAccessIDCancelAccessPut(supportAccessID: string, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentitySupportAccessSupportAccessIDCancelAccessPut(supportAccessID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} supportAccessID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessSupportAccessIDHistoryGet(supportAccessID: string, options?: any): AxiosPromise<Array<SupportAccessSupportAccessHistoryDTO>> {
            return localVarFp.apiIdentitySupportAccessSupportAccessIDHistoryGet(supportAccessID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} supportAccessID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentitySupportAccessSupportAccessIDRemoveAccessPut(supportAccessID: string, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentitySupportAccessSupportAccessIDRemoveAccessPut(supportAccessID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupportAccessApi - object-oriented interface
 * @export
 * @class SupportAccessApi
 * @extends {BaseAPI}
 */
export class SupportAccessApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAccessApi
     */
    public apiIdentitySupportAccessActiveAccessGet(options?: RawAxiosRequestConfig) {
        return SupportAccessApiFp(this.configuration).apiIdentitySupportAccessActiveAccessGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesGetAdminsForClientQuery} [queriesGetAdminsForClientQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAccessApi
     */
    public apiIdentitySupportAccessClientAdminsGet(queriesGetAdminsForClientQuery?: QueriesGetAdminsForClientQuery, options?: RawAxiosRequestConfig) {
        return SupportAccessApiFp(this.configuration).apiIdentitySupportAccessClientAdminsGet(queriesGetAdminsForClientQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAccessApi
     */
    public apiIdentitySupportAccessClientHistoryGet(options?: RawAxiosRequestConfig) {
        return SupportAccessApiFp(this.configuration).apiIdentitySupportAccessClientHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAccessApi
     */
    public apiIdentitySupportAccessClientsAndDurationGet(options?: RawAxiosRequestConfig) {
        return SupportAccessApiFp(this.configuration).apiIdentitySupportAccessClientsAndDurationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAccessApi
     */
    public apiIdentitySupportAccessDenyAccessPut(options?: RawAxiosRequestConfig) {
        return SupportAccessApiFp(this.configuration).apiIdentitySupportAccessDenyAccessPut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAccessApi
     */
    public apiIdentitySupportAccessGrantAccessPut(options?: RawAxiosRequestConfig) {
        return SupportAccessApiFp(this.configuration).apiIdentitySupportAccessGrantAccessPut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAccessApi
     */
    public apiIdentitySupportAccessPendingRequestsGet(options?: RawAxiosRequestConfig) {
        return SupportAccessApiFp(this.configuration).apiIdentitySupportAccessPendingRequestsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [searchTerm] 
     * @param {number} [page] 
     * @param {number} [rowsPerPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAccessApi
     */
    public apiIdentitySupportAccessPreviousAccessGet(searchTerm?: string, page?: number, rowsPerPage?: number, options?: RawAxiosRequestConfig) {
        return SupportAccessApiFp(this.configuration).apiIdentitySupportAccessPreviousAccessGet(searchTerm, page, rowsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesRequestSupportAccessCommand} [queriesRequestSupportAccessCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAccessApi
     */
    public apiIdentitySupportAccessRequestAccessPost(queriesRequestSupportAccessCommand?: QueriesRequestSupportAccessCommand, options?: RawAxiosRequestConfig) {
        return SupportAccessApiFp(this.configuration).apiIdentitySupportAccessRequestAccessPost(queriesRequestSupportAccessCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAccessApi
     */
    public apiIdentitySupportAccessRevokeAccessPut(options?: RawAxiosRequestConfig) {
        return SupportAccessApiFp(this.configuration).apiIdentitySupportAccessRevokeAccessPut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} supportAccessID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAccessApi
     */
    public apiIdentitySupportAccessSupportAccessIDCancelAccessPut(supportAccessID: string, options?: RawAxiosRequestConfig) {
        return SupportAccessApiFp(this.configuration).apiIdentitySupportAccessSupportAccessIDCancelAccessPut(supportAccessID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} supportAccessID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAccessApi
     */
    public apiIdentitySupportAccessSupportAccessIDHistoryGet(supportAccessID: string, options?: RawAxiosRequestConfig) {
        return SupportAccessApiFp(this.configuration).apiIdentitySupportAccessSupportAccessIDHistoryGet(supportAccessID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} supportAccessID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportAccessApi
     */
    public apiIdentitySupportAccessSupportAccessIDRemoveAccessPut(supportAccessID: string, options?: RawAxiosRequestConfig) {
        return SupportAccessApiFp(this.configuration).apiIdentitySupportAccessSupportAccessIDRemoveAccessPut(supportAccessID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserContextApi - axios parameter creator
 * @export
 */
export const UserContextApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserContextCheckValidCookieGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserContext/check-valid-cookie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserContextApi - functional programming interface
 * @export
 */
export const UserContextApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserContextApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserContextCheckValidCookieGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetSubdomainForUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserContextCheckValidCookieGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserContextApi.apiIdentityUserContextCheckValidCookieGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserContextApi - factory interface
 * @export
 */
export const UserContextApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserContextApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserContextCheckValidCookieGet(options?: any): AxiosPromise<QueriesGetSubdomainForUserResponse> {
            return localVarFp.apiIdentityUserContextCheckValidCookieGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserContextApi - object-oriented interface
 * @export
 * @class UserContextApi
 * @extends {BaseAPI}
 */
export class UserContextApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserContextApi
     */
    public apiIdentityUserContextCheckValidCookieGet(options?: RawAxiosRequestConfig) {
        return UserContextApiFp(this.configuration).apiIdentityUserContextCheckValidCookieGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserManagementApi - axios parameter creator
 * @export
 */
export const UserManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {boolean} active 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementActiveActivePut: async (active: boolean, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'active' is not null or undefined
            assertParamExists('apiIdentityUserManagementActiveActivePut', 'active', active)
            const localVarPath = `/api/identity/UserManagement/active/{active}`
                .replace(`{${"active"}}`, encodeURIComponent(String(active)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {boolean} [newActiveStatus] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementActivePut: async (searchTerm?: string, showInactive?: boolean, newActiveStatus?: boolean, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (showInactive !== undefined) {
                localVarQueryParameter['showInactive'] = showInactive;
            }

            if (newActiveStatus !== undefined) {
                localVarQueryParameter['newActiveStatus'] = newActiveStatus;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementBulkForgotPasswordPost: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/bulk-forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementBulkUnlockPut: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/bulk-unlock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementClearTwoFactorTokensPut: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/clear-two-factor-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementCurrentUserProfileGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/current-user-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsEditUserCommand} [commandsEditUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementCurrentUserProfilePut: async (commandsEditUserCommand?: CommandsEditUserCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/current-user-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsEditUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dropboxName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementDropboxDropboxNameAvatarGet: async (dropboxName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dropboxName' is not null or undefined
            assertParamExists('apiIdentityUserManagementDropboxDropboxNameAvatarGet', 'dropboxName', dropboxName)
            const localVarPath = `/api/identity/UserManagement/dropbox/{dropboxName}/avatar`
                .replace(`{${"dropboxName"}}`, encodeURIComponent(String(dropboxName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dropboxName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementDropboxDropboxNameGet: async (dropboxName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dropboxName' is not null or undefined
            assertParamExists('apiIdentityUserManagementDropboxDropboxNameGet', 'dropboxName', dropboxName)
            const localVarPath = `/api/identity/UserManagement/dropbox/{dropboxName}`
                .replace(`{${"dropboxName"}}`, encodeURIComponent(String(dropboxName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementEmailEmailGet: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('apiIdentityUserManagementEmailEmailGet', 'email', email)
            const localVarPath = `/api/identity/UserManagement/email/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {UserManageUsersSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {boolean} [showInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementGet: async (searchTerm?: string, sortColumn?: UserManageUsersSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, showInactive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (rowsPerPage !== undefined) {
                localVarQueryParameter['rowsPerPage'] = rowsPerPage;
            }

            if (showInactive !== undefined) {
                localVarQueryParameter['showInactive'] = showInactive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementMultiResendActivationEmailPost: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/multi-resend-activation-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateUserCommand} [commandsCreateUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementPost: async (commandsCreateUserCommand?: CommandsCreateUserCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdateUserCommand} [commandsUpdateUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementPut: async (commandsUpdateUserCommand?: CommandsUpdateUserCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementRolesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementSelectAllBulkForgotPasswordPost: async (searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/select-all-bulk-forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (showInactive !== undefined) {
                localVarQueryParameter['showInactive'] = showInactive;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementSelectAllBulkUnlockPut: async (searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/select-all-bulk-unlock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (showInactive !== undefined) {
                localVarQueryParameter['showInactive'] = showInactive;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementSelectAllClearTwoFactorTokensPut: async (searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/select-all-clear-two-factor-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (showInactive !== undefined) {
                localVarQueryParameter['showInactive'] = showInactive;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementSelectAllResendActivationEmailPost: async (searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/select-all-resend-activation-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (showInactive !== undefined) {
                localVarQueryParameter['showInactive'] = showInactive;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementServicesGet: async (activeOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (activeOnly !== undefined) {
                localVarQueryParameter['activeOnly'] = activeOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementUserIDAvatarGet: async (userID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('apiIdentityUserManagementUserIDAvatarGet', 'userID', userID)
            const localVarPath = `/api/identity/UserManagement/{userID}/avatar`
                .replace(`{${"userID"}}`, encodeURIComponent(String(userID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userID 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementUserIDAvatarPost: async (userID: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('apiIdentityUserManagementUserIDAvatarPost', 'userID', userID)
            const localVarPath = `/api/identity/UserManagement/{userID}/avatar`
                .replace(`{${"userID"}}`, encodeURIComponent(String(userID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementUserIDDelete: async (userID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('apiIdentityUserManagementUserIDDelete', 'userID', userID)
            const localVarPath = `/api/identity/UserManagement/{userID}`
                .replace(`{${"userID"}}`, encodeURIComponent(String(userID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementUserIDGet: async (userID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('apiIdentityUserManagementUserIDGet', 'userID', userID)
            const localVarPath = `/api/identity/UserManagement/{userID}`
                .replace(`{${"userID"}}`, encodeURIComponent(String(userID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userID 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementUserIDRemoveFromClientClientIDPost: async (userID: string, clientID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('apiIdentityUserManagementUserIDRemoveFromClientClientIDPost', 'userID', userID)
            // verify required parameter 'clientID' is not null or undefined
            assertParamExists('apiIdentityUserManagementUserIDRemoveFromClientClientIDPost', 'clientID', clientID)
            const localVarPath = `/api/identity/UserManagement/{userID}/remove-from-client/{clientID}`
                .replace(`{${"userID"}}`, encodeURIComponent(String(userID)))
                .replace(`{${"clientID"}}`, encodeURIComponent(String(clientID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [dropboxName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementValidateDropboxNamePost: async (dropboxName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/validate-dropbox-name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dropboxName !== undefined) {
                localVarQueryParameter['dropboxName'] = dropboxName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {string} [userID] 
         * @param {string} [subdomain] 
         * @param {string} [redirectID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementWelcomeGet: async (token?: string, userID?: string, subdomain?: string, redirectID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/UserManagement/welcome`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (userID !== undefined) {
                localVarQueryParameter['userID'] = userID;
            }

            if (subdomain !== undefined) {
                localVarQueryParameter['subdomain'] = subdomain;
            }

            if (redirectID !== undefined) {
                localVarQueryParameter['redirectID'] = redirectID;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserManagementApi - functional programming interface
 * @export
 */
export const UserManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {boolean} active 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementActiveActivePut(active: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementActiveActivePut(active, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementActiveActivePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {boolean} [newActiveStatus] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementActivePut(searchTerm?: string, showInactive?: boolean, newActiveStatus?: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementActivePut(searchTerm, showInactive, newActiveStatus, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementActivePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementBulkForgotPasswordPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementBulkForgotPasswordPost(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementBulkForgotPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementBulkUnlockPut(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementBulkUnlockPut(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementBulkUnlockPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementClearTwoFactorTokensPut(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementClearTwoFactorTokensPut(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementClearTwoFactorTokensPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementCurrentUserProfileGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGetUserFromEmailResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementCurrentUserProfileGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementCurrentUserProfileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsEditUserCommand} [commandsEditUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementCurrentUserProfilePut(commandsEditUserCommand?: CommandsEditUserCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementCurrentUserProfilePut(commandsEditUserCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementCurrentUserProfilePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} dropboxName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementDropboxDropboxNameAvatarGet(dropboxName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementDropboxDropboxNameAvatarGet(dropboxName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementDropboxDropboxNameAvatarGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} dropboxName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementDropboxDropboxNameGet(dropboxName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetDropboxResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementDropboxDropboxNameGet(dropboxName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementDropboxDropboxNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementEmailEmailGet(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGetUserFromEmailResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementEmailEmailGet(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementEmailEmailGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {UserManageUsersSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {boolean} [showInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementGet(searchTerm?: string, sortColumn?: UserManageUsersSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, showInactive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAllUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementGet(searchTerm, sortColumn, sortDirection, page, rowsPerPage, showInactive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementMultiResendActivationEmailPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementMultiResendActivationEmailPost(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementMultiResendActivationEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateUserCommand} [commandsCreateUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementPost(commandsCreateUserCommand?: CommandsCreateUserCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCreateUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementPost(commandsCreateUserCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdateUserCommand} [commandsUpdateUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementPut(commandsUpdateUserCommand?: CommandsUpdateUserCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsUpdateUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementPut(commandsUpdateUserCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementRolesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModelsRole>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementRolesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementSelectAllBulkForgotPasswordPost(searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementSelectAllBulkForgotPasswordPost(searchTerm, showInactive, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementSelectAllBulkForgotPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementSelectAllBulkUnlockPut(searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementSelectAllBulkUnlockPut(searchTerm, showInactive, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementSelectAllBulkUnlockPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementSelectAllClearTwoFactorTokensPut(searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementSelectAllClearTwoFactorTokensPut(searchTerm, showInactive, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementSelectAllClearTwoFactorTokensPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementSelectAllResendActivationEmailPost(searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementSelectAllResendActivationEmailPost(searchTerm, showInactive, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementSelectAllResendActivationEmailPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementServicesGet(activeOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueriesGetServicesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementServicesGet(activeOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementServicesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementUserIDAvatarGet(userID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementUserIDAvatarGet(userID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementUserIDAvatarGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userID 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementUserIDAvatarPost(userID: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementUserIDAvatarPost(userID, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementUserIDAvatarPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementUserIDDelete(userID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementUserIDDelete(userID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementUserIDDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementUserIDGet(userID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementUserIDGet(userID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementUserIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userID 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementUserIDRemoveFromClientClientIDPost(userID: string, clientID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementUserIDRemoveFromClientClientIDPost(userID, clientID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementUserIDRemoveFromClientClientIDPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [dropboxName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementValidateDropboxNamePost(dropboxName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementValidateDropboxNamePost(dropboxName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementValidateDropboxNamePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {string} [userID] 
         * @param {string} [subdomain] 
         * @param {string} [redirectID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUserManagementWelcomeGet(token?: string, userID?: string, subdomain?: string, redirectID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUserManagementWelcomeGet(token, userID, subdomain, redirectID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.apiIdentityUserManagementWelcomeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserManagementApi - factory interface
 * @export
 */
export const UserManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserManagementApiFp(configuration)
    return {
        /**
         * 
         * @param {boolean} active 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementActiveActivePut(active: boolean, requestBody?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiIdentityUserManagementActiveActivePut(active, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {boolean} [newActiveStatus] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementActivePut(searchTerm?: string, showInactive?: boolean, newActiveStatus?: boolean, requestBody?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiIdentityUserManagementActivePut(searchTerm, showInactive, newActiveStatus, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementBulkForgotPasswordPost(requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.apiIdentityUserManagementBulkForgotPasswordPost(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementBulkUnlockPut(requestBody?: Array<string>, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityUserManagementBulkUnlockPut(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementClearTwoFactorTokensPut(requestBody?: Array<string>, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityUserManagementClearTwoFactorTokensPut(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementCurrentUserProfileGet(options?: any): AxiosPromise<UserGetUserFromEmailResponseDTO> {
            return localVarFp.apiIdentityUserManagementCurrentUserProfileGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsEditUserCommand} [commandsEditUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementCurrentUserProfilePut(commandsEditUserCommand?: CommandsEditUserCommand, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentityUserManagementCurrentUserProfilePut(commandsEditUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} dropboxName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementDropboxDropboxNameAvatarGet(dropboxName: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityUserManagementDropboxDropboxNameAvatarGet(dropboxName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} dropboxName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementDropboxDropboxNameGet(dropboxName: string, options?: any): AxiosPromise<QueriesGetDropboxResponse> {
            return localVarFp.apiIdentityUserManagementDropboxDropboxNameGet(dropboxName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementEmailEmailGet(email: string, options?: any): AxiosPromise<UserGetUserFromEmailResponseDTO> {
            return localVarFp.apiIdentityUserManagementEmailEmailGet(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {UserManageUsersSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {boolean} [showInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementGet(searchTerm?: string, sortColumn?: UserManageUsersSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, showInactive?: boolean, options?: any): AxiosPromise<QueriesGetAllUsersResponse> {
            return localVarFp.apiIdentityUserManagementGet(searchTerm, sortColumn, sortDirection, page, rowsPerPage, showInactive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementMultiResendActivationEmailPost(requestBody?: Array<string>, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityUserManagementMultiResendActivationEmailPost(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateUserCommand} [commandsCreateUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementPost(commandsCreateUserCommand?: CommandsCreateUserCommand, options?: any): AxiosPromise<UserCreateUserResponse> {
            return localVarFp.apiIdentityUserManagementPost(commandsCreateUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdateUserCommand} [commandsUpdateUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementPut(commandsUpdateUserCommand?: CommandsUpdateUserCommand, options?: any): AxiosPromise<CommandsUpdateUserResponse> {
            return localVarFp.apiIdentityUserManagementPut(commandsUpdateUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementRolesGet(options?: any): AxiosPromise<Array<ModelsRole>> {
            return localVarFp.apiIdentityUserManagementRolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementSelectAllBulkForgotPasswordPost(searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.apiIdentityUserManagementSelectAllBulkForgotPasswordPost(searchTerm, showInactive, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementSelectAllBulkUnlockPut(searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiIdentityUserManagementSelectAllBulkUnlockPut(searchTerm, showInactive, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementSelectAllClearTwoFactorTokensPut(searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiIdentityUserManagementSelectAllClearTwoFactorTokensPut(searchTerm, showInactive, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {boolean} [showInactive] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementSelectAllResendActivationEmailPost(searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options?: any): AxiosPromise<object> {
            return localVarFp.apiIdentityUserManagementSelectAllResendActivationEmailPost(searchTerm, showInactive, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [activeOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementServicesGet(activeOnly?: boolean, options?: any): AxiosPromise<Array<QueriesGetServicesResponse>> {
            return localVarFp.apiIdentityUserManagementServicesGet(activeOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementUserIDAvatarGet(userID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityUserManagementUserIDAvatarGet(userID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userID 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementUserIDAvatarPost(userID: string, file?: File, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentityUserManagementUserIDAvatarPost(userID, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementUserIDDelete(userID: string, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentityUserManagementUserIDDelete(userID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementUserIDGet(userID: string, options?: any): AxiosPromise<QueriesGetUserResponse> {
            return localVarFp.apiIdentityUserManagementUserIDGet(userID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userID 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementUserIDRemoveFromClientClientIDPost(userID: string, clientID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityUserManagementUserIDRemoveFromClientClientIDPost(userID, clientID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [dropboxName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementValidateDropboxNamePost(dropboxName?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiIdentityUserManagementValidateDropboxNamePost(dropboxName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {string} [userID] 
         * @param {string} [subdomain] 
         * @param {string} [redirectID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUserManagementWelcomeGet(token?: string, userID?: string, subdomain?: string, redirectID?: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityUserManagementWelcomeGet(token, userID, subdomain, redirectID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserManagementApi - object-oriented interface
 * @export
 * @class UserManagementApi
 * @extends {BaseAPI}
 */
export class UserManagementApi extends BaseAPI {
    /**
     * 
     * @param {boolean} active 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementActiveActivePut(active: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementActiveActivePut(active, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [searchTerm] 
     * @param {boolean} [showInactive] 
     * @param {boolean} [newActiveStatus] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementActivePut(searchTerm?: string, showInactive?: boolean, newActiveStatus?: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementActivePut(searchTerm, showInactive, newActiveStatus, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementBulkForgotPasswordPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementBulkForgotPasswordPost(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementBulkUnlockPut(requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementBulkUnlockPut(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementClearTwoFactorTokensPut(requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementClearTwoFactorTokensPut(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementCurrentUserProfileGet(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementCurrentUserProfileGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsEditUserCommand} [commandsEditUserCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementCurrentUserProfilePut(commandsEditUserCommand?: CommandsEditUserCommand, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementCurrentUserProfilePut(commandsEditUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} dropboxName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementDropboxDropboxNameAvatarGet(dropboxName: string, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementDropboxDropboxNameAvatarGet(dropboxName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} dropboxName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementDropboxDropboxNameGet(dropboxName: string, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementDropboxDropboxNameGet(dropboxName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementEmailEmailGet(email: string, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementEmailEmailGet(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [searchTerm] 
     * @param {UserManageUsersSortColumn} [sortColumn] 
     * @param {EnumerationsSortDirection} [sortDirection] 
     * @param {number} [page] 
     * @param {number} [rowsPerPage] 
     * @param {boolean} [showInactive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementGet(searchTerm?: string, sortColumn?: UserManageUsersSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, showInactive?: boolean, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementGet(searchTerm, sortColumn, sortDirection, page, rowsPerPage, showInactive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementMultiResendActivationEmailPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementMultiResendActivationEmailPost(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateUserCommand} [commandsCreateUserCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementPost(commandsCreateUserCommand?: CommandsCreateUserCommand, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementPost(commandsCreateUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdateUserCommand} [commandsUpdateUserCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementPut(commandsUpdateUserCommand?: CommandsUpdateUserCommand, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementPut(commandsUpdateUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementRolesGet(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementRolesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [searchTerm] 
     * @param {boolean} [showInactive] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementSelectAllBulkForgotPasswordPost(searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementSelectAllBulkForgotPasswordPost(searchTerm, showInactive, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [searchTerm] 
     * @param {boolean} [showInactive] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementSelectAllBulkUnlockPut(searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementSelectAllBulkUnlockPut(searchTerm, showInactive, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [searchTerm] 
     * @param {boolean} [showInactive] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementSelectAllClearTwoFactorTokensPut(searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementSelectAllClearTwoFactorTokensPut(searchTerm, showInactive, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [searchTerm] 
     * @param {boolean} [showInactive] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementSelectAllResendActivationEmailPost(searchTerm?: string, showInactive?: boolean, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementSelectAllResendActivationEmailPost(searchTerm, showInactive, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [activeOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementServicesGet(activeOnly?: boolean, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementServicesGet(activeOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementUserIDAvatarGet(userID: string, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementUserIDAvatarGet(userID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userID 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementUserIDAvatarPost(userID: string, file?: File, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementUserIDAvatarPost(userID, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementUserIDDelete(userID: string, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementUserIDDelete(userID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementUserIDGet(userID: string, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementUserIDGet(userID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userID 
     * @param {string} clientID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementUserIDRemoveFromClientClientIDPost(userID: string, clientID: string, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementUserIDRemoveFromClientClientIDPost(userID, clientID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [dropboxName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementValidateDropboxNamePost(dropboxName?: string, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementValidateDropboxNamePost(dropboxName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {string} [userID] 
     * @param {string} [subdomain] 
     * @param {string} [redirectID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public apiIdentityUserManagementWelcomeGet(token?: string, userID?: string, subdomain?: string, redirectID?: string, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).apiIdentityUserManagementWelcomeGet(token, userID, subdomain, redirectID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersAvatarGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Users/avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersAvatarPost: async (file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Users/avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersClientsGet: async (searchTerm?: string, sortDirection?: EnumerationsSortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Users/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersConsultantsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Users/consultants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersDocumentCenterGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Users/document-center`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersServiceDeliverablesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Users/service-deliverables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateSRAUserRequest} [commandsCreateSRAUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersSraUserPost: async (commandsCreateSRAUserRequest?: CommandsCreateSRAUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Users/sra-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateSRAUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersSwitchClientClientIDPut: async (clientID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientID' is not null or undefined
            assertParamExists('apiIdentityUsersSwitchClientClientIDPut', 'clientID', clientID)
            const localVarPath = `/api/identity/Users/switch-client/{clientID}`
                .replace(`{${"clientID"}}`, encodeURIComponent(String(clientID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateDocumentCenterUserRequest} [commandsCreateDocumentCenterUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersUserPost: async (commandsCreateDocumentCenterUserRequest?: CommandsCreateDocumentCenterUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Users/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateDocumentCenterUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersAvatarGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersAvatarGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiIdentityUsersAvatarGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersAvatarPost(file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersAvatarPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiIdentityUsersAvatarPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersClientsGet(searchTerm?: string, sortDirection?: EnumerationsSortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientAvailableClient>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersClientsGet(searchTerm, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiIdentityUsersClientsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersConsultantsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserAvailableUser>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersConsultantsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiIdentityUsersConsultantsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersDocumentCenterGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueriesDocumentCenterUser>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersDocumentCenterGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiIdentityUsersDocumentCenterGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersServiceDeliverablesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueriesServiceDeliverablesUser>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersServiceDeliverablesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiIdentityUsersServiceDeliverablesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateSRAUserRequest} [commandsCreateSRAUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersSraUserPost(commandsCreateSRAUserRequest?: CommandsCreateSRAUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCreateUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersSraUserPost(commandsCreateSRAUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiIdentityUsersSraUserPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersSwitchClientClientIDPut(clientID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersSwitchClientClientIDPut(clientID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiIdentityUsersSwitchClientClientIDPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateDocumentCenterUserRequest} [commandsCreateDocumentCenterUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityUsersUserPost(commandsCreateDocumentCenterUserRequest?: CommandsCreateDocumentCenterUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCreateUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityUsersUserPost(commandsCreateDocumentCenterUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiIdentityUsersUserPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersAvatarGet(options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityUsersAvatarGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersAvatarPost(file?: File, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiIdentityUsersAvatarPost(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersClientsGet(searchTerm?: string, sortDirection?: EnumerationsSortDirection, options?: any): AxiosPromise<Array<ClientAvailableClient>> {
            return localVarFp.apiIdentityUsersClientsGet(searchTerm, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersConsultantsGet(options?: any): AxiosPromise<Array<UserAvailableUser>> {
            return localVarFp.apiIdentityUsersConsultantsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersDocumentCenterGet(options?: any): AxiosPromise<Array<QueriesDocumentCenterUser>> {
            return localVarFp.apiIdentityUsersDocumentCenterGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersServiceDeliverablesGet(options?: any): AxiosPromise<Array<QueriesServiceDeliverablesUser>> {
            return localVarFp.apiIdentityUsersServiceDeliverablesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateSRAUserRequest} [commandsCreateSRAUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersSraUserPost(commandsCreateSRAUserRequest?: CommandsCreateSRAUserRequest, options?: any): AxiosPromise<UserCreateUserResponse> {
            return localVarFp.apiIdentityUsersSraUserPost(commandsCreateSRAUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersSwitchClientClientIDPut(clientID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityUsersSwitchClientClientIDPut(clientID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateDocumentCenterUserRequest} [commandsCreateDocumentCenterUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityUsersUserPost(commandsCreateDocumentCenterUserRequest?: CommandsCreateDocumentCenterUserRequest, options?: any): AxiosPromise<UserCreateUserResponse> {
            return localVarFp.apiIdentityUsersUserPost(commandsCreateDocumentCenterUserRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiIdentityUsersAvatarGet(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiIdentityUsersAvatarGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiIdentityUsersAvatarPost(file?: File, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiIdentityUsersAvatarPost(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [searchTerm] 
     * @param {EnumerationsSortDirection} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiIdentityUsersClientsGet(searchTerm?: string, sortDirection?: EnumerationsSortDirection, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiIdentityUsersClientsGet(searchTerm, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiIdentityUsersConsultantsGet(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiIdentityUsersConsultantsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiIdentityUsersDocumentCenterGet(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiIdentityUsersDocumentCenterGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiIdentityUsersServiceDeliverablesGet(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiIdentityUsersServiceDeliverablesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateSRAUserRequest} [commandsCreateSRAUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiIdentityUsersSraUserPost(commandsCreateSRAUserRequest?: CommandsCreateSRAUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiIdentityUsersSraUserPost(commandsCreateSRAUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiIdentityUsersSwitchClientClientIDPut(clientID: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiIdentityUsersSwitchClientClientIDPut(clientID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateDocumentCenterUserRequest} [commandsCreateDocumentCenterUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiIdentityUsersUserPost(commandsCreateDocumentCenterUserRequest?: CommandsCreateDocumentCenterUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiIdentityUsersUserPost(commandsCreateDocumentCenterUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VerifyApi - axios parameter creator
 * @export
 */
export const VerifyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityVerifyCheckResetGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Verify/check-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityVerifyCheckWelcomeGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Verify/check-welcome`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [t] 
         * @param {string} [u] 
         * @param {string} [d] 
         * @param {string} [s] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityVerifyForgotGet: async (t?: string, u?: string, d?: string, s?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Verify/forgot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (t !== undefined) {
                localVarQueryParameter['t'] = t;
            }

            if (u !== undefined) {
                localVarQueryParameter['u'] = u;
            }

            if (d !== undefined) {
                localVarQueryParameter['d'] = d;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [u] 
         * @param {string} [d] 
         * @param {string} [r] 
         * @param {string} [s] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityVerifyRegistrationRequiredGet: async (u?: string, d?: string, r?: string, s?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Verify/registration-required`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (u !== undefined) {
                localVarQueryParameter['u'] = u;
            }

            if (d !== undefined) {
                localVarQueryParameter['d'] = d;
            }

            if (r !== undefined) {
                localVarQueryParameter['r'] = r;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [t] 
         * @param {string} [u] 
         * @param {string} [d] 
         * @param {string} [r] 
         * @param {string} [s] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityVerifyWelcomeGet: async (t?: string, u?: string, d?: string, r?: string, s?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/Verify/welcome`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (t !== undefined) {
                localVarQueryParameter['t'] = t;
            }

            if (u !== undefined) {
                localVarQueryParameter['u'] = u;
            }

            if (d !== undefined) {
                localVarQueryParameter['d'] = d;
            }

            if (r !== undefined) {
                localVarQueryParameter['r'] = r;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VerifyApi - functional programming interface
 * @export
 */
export const VerifyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VerifyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityVerifyCheckResetGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityVerifyCheckResetGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifyApi.apiIdentityVerifyCheckResetGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityVerifyCheckWelcomeGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityVerifyCheckWelcomeGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifyApi.apiIdentityVerifyCheckWelcomeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [t] 
         * @param {string} [u] 
         * @param {string} [d] 
         * @param {string} [s] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityVerifyForgotGet(t?: string, u?: string, d?: string, s?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityVerifyForgotGet(t, u, d, s, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifyApi.apiIdentityVerifyForgotGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [u] 
         * @param {string} [d] 
         * @param {string} [r] 
         * @param {string} [s] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityVerifyRegistrationRequiredGet(u?: string, d?: string, r?: string, s?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityVerifyRegistrationRequiredGet(u, d, r, s, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifyApi.apiIdentityVerifyRegistrationRequiredGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [t] 
         * @param {string} [u] 
         * @param {string} [d] 
         * @param {string} [r] 
         * @param {string} [s] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityVerifyWelcomeGet(t?: string, u?: string, d?: string, r?: string, s?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityVerifyWelcomeGet(t, u, d, r, s, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifyApi.apiIdentityVerifyWelcomeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VerifyApi - factory interface
 * @export
 */
export const VerifyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VerifyApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityVerifyCheckResetGet(options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityVerifyCheckResetGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityVerifyCheckWelcomeGet(options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityVerifyCheckWelcomeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [t] 
         * @param {string} [u] 
         * @param {string} [d] 
         * @param {string} [s] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityVerifyForgotGet(t?: string, u?: string, d?: string, s?: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityVerifyForgotGet(t, u, d, s, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [u] 
         * @param {string} [d] 
         * @param {string} [r] 
         * @param {string} [s] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityVerifyRegistrationRequiredGet(u?: string, d?: string, r?: string, s?: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityVerifyRegistrationRequiredGet(u, d, r, s, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [t] 
         * @param {string} [u] 
         * @param {string} [d] 
         * @param {string} [r] 
         * @param {string} [s] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityVerifyWelcomeGet(t?: string, u?: string, d?: string, r?: string, s?: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiIdentityVerifyWelcomeGet(t, u, d, r, s, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VerifyApi - object-oriented interface
 * @export
 * @class VerifyApi
 * @extends {BaseAPI}
 */
export class VerifyApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifyApi
     */
    public apiIdentityVerifyCheckResetGet(options?: RawAxiosRequestConfig) {
        return VerifyApiFp(this.configuration).apiIdentityVerifyCheckResetGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifyApi
     */
    public apiIdentityVerifyCheckWelcomeGet(options?: RawAxiosRequestConfig) {
        return VerifyApiFp(this.configuration).apiIdentityVerifyCheckWelcomeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [t] 
     * @param {string} [u] 
     * @param {string} [d] 
     * @param {string} [s] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifyApi
     */
    public apiIdentityVerifyForgotGet(t?: string, u?: string, d?: string, s?: string, options?: RawAxiosRequestConfig) {
        return VerifyApiFp(this.configuration).apiIdentityVerifyForgotGet(t, u, d, s, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [u] 
     * @param {string} [d] 
     * @param {string} [r] 
     * @param {string} [s] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifyApi
     */
    public apiIdentityVerifyRegistrationRequiredGet(u?: string, d?: string, r?: string, s?: string, options?: RawAxiosRequestConfig) {
        return VerifyApiFp(this.configuration).apiIdentityVerifyRegistrationRequiredGet(u, d, r, s, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [t] 
     * @param {string} [u] 
     * @param {string} [d] 
     * @param {string} [r] 
     * @param {string} [s] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifyApi
     */
    public apiIdentityVerifyWelcomeGet(t?: string, u?: string, d?: string, r?: string, s?: string, options?: RawAxiosRequestConfig) {
        return VerifyApiFp(this.configuration).apiIdentityVerifyWelcomeGet(t, u, d, r, s, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ViewAsUserApi - axios parameter creator
 * @export
 */
export const ViewAsUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userToViewAsID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityViewAsUserUserToViewAsIDPost: async (userToViewAsID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userToViewAsID' is not null or undefined
            assertParamExists('apiIdentityViewAsUserUserToViewAsIDPost', 'userToViewAsID', userToViewAsID)
            const localVarPath = `/api/identity/ViewAsUser/{userToViewAsID}`
                .replace(`{${"userToViewAsID"}}`, encodeURIComponent(String(userToViewAsID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityViewAsUserUsersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/ViewAsUser/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ViewAsUserApi - functional programming interface
 * @export
 */
export const ViewAsUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ViewAsUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userToViewAsID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityViewAsUserUserToViewAsIDPost(userToViewAsID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityViewAsUserUserToViewAsIDPost(userToViewAsID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewAsUserApi.apiIdentityViewAsUserUserToViewAsIDPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityViewAsUserUsersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueriesUserToViewAs>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityViewAsUserUsersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewAsUserApi.apiIdentityViewAsUserUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ViewAsUserApi - factory interface
 * @export
 */
export const ViewAsUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ViewAsUserApiFp(configuration)
    return {
        /**
         * 
         * @param {string} userToViewAsID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityViewAsUserUserToViewAsIDPost(userToViewAsID: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiIdentityViewAsUserUserToViewAsIDPost(userToViewAsID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityViewAsUserUsersGet(options?: any): AxiosPromise<Array<QueriesUserToViewAs>> {
            return localVarFp.apiIdentityViewAsUserUsersGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ViewAsUserApi - object-oriented interface
 * @export
 * @class ViewAsUserApi
 * @extends {BaseAPI}
 */
export class ViewAsUserApi extends BaseAPI {
    /**
     * 
     * @param {string} userToViewAsID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewAsUserApi
     */
    public apiIdentityViewAsUserUserToViewAsIDPost(userToViewAsID: string, options?: RawAxiosRequestConfig) {
        return ViewAsUserApiFp(this.configuration).apiIdentityViewAsUserUserToViewAsIDPost(userToViewAsID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewAsUserApi
     */
    public apiIdentityViewAsUserUsersGet(options?: RawAxiosRequestConfig) {
        return ViewAsUserApiFp(this.configuration).apiIdentityViewAsUserUsersGet(options).then((request) => request(this.axios, this.basePath));
    }
}



